<template>
    <div class="approval-pop">
        <div class="instances-content">
             <el-tabs style="width: 99%;" :tab-position="tabPosition" v-model="tabName" @tab-click="handleTabClick" type="border-card" class="form-card">
              <!-- 审批表单 -->
              <el-tab-pane name="first" label="审批表单">
                <div class="approval-basic">
                    <div class="name" style="display:flex;width: 100%;height:36px;line-height:36px;">
                        <div class="name-label">
                            审批名称：<span style="color:red;">*</span>
                        </div>
                        <div class="name-text" style="flex:1;padding-right: 20px;margin-left:10px;margin-top:5px;">
                            <el-input :disabled="isRead || approvalForm.nameReadOnly" v-model="approvalForm.approvalName" style="font-weight: 700; color: rgb(48, 49, 51); font-size: 16px;" ></el-input>
                        </div>
                    </div>
                    <div class="approval-user" style="margin-top:10px;">
                        <div v-if="approvalInfo.approvalMethod == 3">
                            <el-steps class="executors" :key="loadTimer" :active="approvalInfo.approvePeopleList.length" :align-center="approvalInfo.approvePeopleList.length > 0">
                                <el-step v-for="(item, index) in approvalInfo.approvePeopleList"  :key="index" align-center>
                                    <el-breadcrumb v-if="item.approvePeoples && item.approvePeoples.length > 0" slot="title" :separator="(item.approveWay == 2?'+':'/')">
                                        <el-breadcrumb-item  v-for="(user, i) in item.approvePeoples" :key="i">{{user.approvePeopleType=='user'?user.selectedUserName:(user.trueName?user.trueName:user.fieldName)}}</el-breadcrumb-item>
                                    </el-breadcrumb>
                                </el-step>
                            </el-steps>
                            <el-steps class="executors-proportion" :key="renderTimer" :active="approvalInfo.approvePeopleList.length" :align-center="approvalInfo.approvePeopleList.length > 0">
                                <el-step v-for="(item, index) in approvalInfo.approvePeopleList" :key="index" align-center>
                                    <el-breadcrumb  slot="title" :separator="(item.approveWay == 2?'+':'/')">
                                        <el-input-number v-model="item.proportion" :precision="0" :step="1" :min="1" :max="100" v-if="item.approveWay == 2" placeholder="会签比例" @change="changeProportionVal(item)"></el-input-number>
                                        <el-tooltip class="item" effect="dark" content="设置会签比例后当会签节点审批通过的人数达到了会签比例数则此审批节点直接通过,不配置则代表会签节点审批人员全部通过后节点状态才算通过,设置数字的单位为百分比,比例最大值为100就是代表百分之一百" placement="top-end">
                                            <i class="el-icon-question" v-if="item.approveWay == 2"></i>
                                        </el-tooltip>
                                    </el-breadcrumb>
                                </el-step>
                            </el-steps>
                        </div>
                        <div v-if="approvalInfo.approvalMethod == 2">
                            <el-steps class="executors" :key="loadTimer" :active="approvalInfo.approvalList.length" :align-center="approvalInfo.approvalList.length > 0">
                                <el-step v-for="(item, index) in approvalInfo.approvalList"  :key="index" align-center  @click.native="chooseApproveUser(index)">
                                    <el-breadcrumb v-if="item && item.length > 0" slot="title" :separator="(approvalInfo.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                        <el-breadcrumb-item  v-for="(user, i) in item" :key="i">{{user.trueName}}</el-breadcrumb-item>
                                    </el-breadcrumb>
                                </el-step>
                                <el-step v-if="!this.approvalForm.approvalUserReadOnly" :key="approvalInfo.approvalList.length + 1" icon="el-icon-circle-plus-outline" @click.native="addApproval"></el-step>
                            </el-steps>
                            <el-steps class="executors-proportion" :key="renderTimer" :active="approvalInfo.approvalList.length" :align-center="approvalInfo.approvalList.length > 0">
                                <el-step v-for="(item, index) in approvalInfo.approvalList" :key="index" align-center>
                                    <el-breadcrumb v-if="item && item.length > 0" slot="title">
                                        <el-input-number v-model="approvalInfo.approvalUserGroupList[index].proportion" :precision="0" :step="1" :min="1" :max="100" v-if="approvalInfo.approvalUserGroupList[index].approvalMultiSignType == 2" placeholder="会签比例" @change="changeProportionVal(item)"></el-input-number>
                                        <el-tooltip class="item" effect="dark" content="设置会签比例后当会签节点审批通过的人数达到了会签比例数则此审批节点直接通过,不配置则代表会签节点审批人员全部通过后节点状态才算通过,设置数字的单位为百分比,比例最大值为100就是代表百分之一百" placement="top-end">
                                            <i class="el-icon-question" v-if="approvalInfo.approvalUserGroupList[index].approvalMultiSignType == 2"></i>
                                        </el-tooltip>
                                    </el-breadcrumb>
                                </el-step>
                            </el-steps>
                        </div>
                        <div v-if="approvalInfo.approvalMethod == 1">
                            <el-steps v-if="totalNum>0" :active="totalNum" align-center>
                                <el-step v-for="(item, index) in selectUsers" :key="index">
                                    <el-breadcrumb slot="title" separator="/">
                                        <el-breadcrumb-item >{{item}}</el-breadcrumb-item>
                                    </el-breadcrumb>
                                </el-step>
                            </el-steps>
                        </div>
                    </div>
                </div>
                <div class="approval-form">
                    <ApprovalForm
                        ref="approvalFormTab"
                        :key="approvalFormLoadTimer"
                        :isRead="isRead"
                        :forms="forms"
                        :btnMode="btnMode"
                        :formData="formData"
                        :approvalStatus="approvalStatus"
                        :approvalTemplateObj="approvalTemplateObj"
                        :processModelFormsObj="processModelFormsObj"
                        :approvalUserList="approvalUserList"
                        :isInstance="isInstance"
                        :instances="instances"
                        />
                </div>
                </el-tab-pane>
                  <!-- 审批表单 -->
                  <el-tab-pane  name="second" label="审批信息">
                     <el-form size="mini" ref="approvalForm"  style="height:100%;overflow-y: auto" :model="approvalForm" label-width="165px">
                         <el-collapse v-model="approvalBaseActiveName" @change="handleChangeCollapse0" accordion>
                            <el-collapse-item name="approvalBaseItem">
                                <template slot="title">
                                  <span style="font-weight: 700;color:#606266;font-size:14px;">基本信息</span>
                                </template>
                              <div>
                                <el-row>
                                  <el-col :span="7" >
                                    <el-form-item label="审批名称"  prop="approvalName"
                                      :rules="[
                                      { required: true, message: '请输入审批名称', trigger: 'blur' }
                                      ]"
                                    >
                                      <el-input :disabled="isRead || approvalForm.nameReadOnly" v-model="approvalForm.approvalName" style="font-weight: 700; color: rgb(48, 49, 51); font-size: 16px;" ></el-input>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="7">
                                      <el-form-item v-if="approvalInfo.approvalMethod == 1" label="审批人员"  prop="selectedUser.selectedUserNames"
                                          :rules="[
                                          { required: true, message: '请选择审批人员', trigger: 'change' },
                                          ]">
                                        <el-row>
                                            <el-col :span="20" >
                                                <el-tooltip :disabled="!selectedUser.selectedUserNames" :content="selectedUser.selectedUserNames" effect="light" placement="top">
                                                    <el-input v-if="isRead || approvalForm.approvalUserReadOnly" disabled v-model="selectedUser.selectedUserNames" ></el-input>
                                                    <el-input v-else readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                                                </el-tooltip>
                                            </el-col>
                                            <el-col :span="4" >
                                                <el-tooltip content="复用历史审批流的审批人信息" placement="top">
                                                    <el-button v-show="!isRead && !approvalForm.approvalUserReadOnly" type="primary" size="mini" icon="el-icon-s-check" title="复用历史负责人" style="margin-left: 5px;" circle @click="handleShowHisApprovalDialog()"></el-button>
                                                </el-tooltip>
                                            </el-col>
                                        </el-row>
                                      </el-form-item>
                                  </el-col>
                                  <el-col :span="5" >
                                      <el-form-item label="审批类型">
                                          <el-input disabled v-model="approvalInfo.approvalTypeName"></el-input>
                                      </el-form-item>
                                  </el-col>
                                  <el-col :span="5" >
                                      <el-form-item label="所属流程">
                                        <el-input v-if="isRead" disabled  v-model="approvalInfo.busiProcessInstanceName" ></el-input>
                                        <el-input v-else readonly  @click.native="chooseProcess" v-model="approvalInfo.busiProcessInstanceName" ></el-input>
                                      </el-form-item>
                                  </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="7">
                                        <el-form-item label="审批模式"
                                        :rules="[
                                          { required: true, message: '请选择审批模式', trigger: 'blur' }
                                          ]"
                                        >
                                            <el-radio-group v-model="approvalForm.orderMode" :disabled="draftFixed">
                                                <el-tooltip class="item" effect="dark" content="可以跨级审批，无先后顺序。注：其他人未审批，但终极审批人通过，则整个审批通过。" placement="top">
                                                    <el-radio :label="0">自由模式</el-radio>
                                                </el-tooltip>
                                                <el-tooltip class="item" effect="dark" content="按设定的审批节点顺序，逐级审批" placement="top">
                                                    <el-radio :label="1">固定模式</el-radio>
                                                </el-tooltip>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7" >
                                        <el-form-item label="时间提醒" >
                                            <el-tooltip class="item" effect="dark" content="到设定时间提醒还未处理审批的审批人" placement="top">
                                                <el-date-picker
                                                    v-model="approvalForm.warnDate"
                                                    type="datetime"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    :editable="true"
                                                    placeholder="选择日期时间"
                                                    :disabled="isRead">
                                                </el-date-picker>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5" >
                                        <el-form-item label="审批时效">
                                            <el-tooltip class="item" effect="dark" content="设置多少小时内完成审批,到期提醒还未处理审批的审批人" placement="top">
                                                <el-input-number v-model="approvalForm.durTime" :min="0" :max="9999" :disabled="isRead" ></el-input-number>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="5" >
                                      <el-form-item label="短信通知">
                                            <el-tooltip class="item" effect="dark" content="是否发送短信通知审批人" placement="top">
                                              <el-checkbox v-model="approvalForm.sendSms" :disabled="isRead"></el-checkbox>
                                            </el-tooltip>
                                      </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row v-if="approvalInfo.approvalMethod > 1">
                                    <el-col :span="7">
                                       <el-form-item label="驳回模式">
                                            <el-radio-group v-model="approvalForm.rejectMode" :disabled="draftFixed" >
                                                <el-tooltip class="item" effect="dark" content="审批进程内，只要有人驳回就将该审批流更新为驳回状态" placement="top">
                                                    <el-radio :label="0" >一票否决</el-radio>
                                                </el-tooltip>
                                                <el-tooltip class="item" effect="dark" content="审批进程内，审批会签节点驳回比例达到指定值才会将该审批流更新为驳回状态" placement="top">
                                                    <el-radio :label="1" >按会签比例</el-radio>
                                                </el-tooltip>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row v-if="btnMode != 2 && !isRead">
                                    <el-form-item v-if="approvalInfo.approvalMethod == 3" label="审批流" class="executor">
                                        <el-row>
                                            <el-col :span="4" >
                                                <el-tooltip content="复用历史审批流的审批人信息" placement="top">
                                                    <el-button type="primary" v-show="!isRead" size="mini" icon="el-icon-s-check" title="复用历史负责人" style="margin-left: 5px;" circle @click="handleShowHisApprovalDialog()"></el-button>
                                                </el-tooltip>
                                            </el-col>
                                            <el-col :span="20" >
                                                <el-steps class="executors" :key="loadTimer" :active="approvalInfo.approvePeopleList.length" :align-center="approvalInfo.approvePeopleList.length > 0">
                                                    <el-step v-for="(item, index) in approvalInfo.approvePeopleList"  :key="index" align-center>
                                                        <el-breadcrumb v-if="item.approvePeoples && item.approvePeoples.length > 0" slot="title" :separator="(item.approveWay == 2?'+':'/')">
                                                            <el-breadcrumb-item  v-for="(user, i) in item.approvePeoples" :key="i">{{user.approvePeopleType=='user'?user.selectedUserName:(user.trueName?user.trueName:user.fieldName)}}</el-breadcrumb-item>
                                                        </el-breadcrumb>
                                                    </el-step>
                                                </el-steps>
                                                <el-steps class="executors-proportion" :key="renderTimer" :active="approvalInfo.approvePeopleList.length" :align-center="approvalInfo.approvePeopleList.length > 0">
                                                    <el-step v-for="(item, index) in approvalInfo.approvePeopleList" :key="index" align-center>
                                                        <el-breadcrumb  slot="title" :separator="(item.approveWay == 2?'+':'/')">
                                                           <el-input-number v-model="item.proportion" :precision="0" :step="1" :min="1" :max="100" v-if="item.approveWay == 2" placeholder="会签比例" @change="changeProportionVal(item)"></el-input-number>
                                                            <el-tooltip class="item" effect="dark" content="设置会签比例后当会签节点审批通过的人数达到了会签比例数则此审批节点直接通过,不配置则代表会签节点审批人员全部通过后节点状态才算通过,设置数字的单位为百分比,比例最大值为100就是代表百分之一百" placement="top-end">
                                                               <i class="el-icon-question" v-if="item.approveWay == 2"></i>
                                                            </el-tooltip>
                                                        </el-breadcrumb>
                                                    </el-step>
                                                </el-steps>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                    <el-form-item v-if="approvalInfo.approvalMethod == 2" label="审批流" class="executor">
                                        <el-row>
                                            <el-col :span="4" >
                                                <el-tooltip content="复用历史审批流的审批人信息" placement="top">
                                                    <el-button type="primary" v-show="!isRead" size="mini" icon="el-icon-s-check" title="复用历史负责人" style="margin-left: 5px;" circle @click="handleShowHisApprovalDialog()"></el-button>
                                                </el-tooltip>
                                            </el-col>
                                            <el-col :span="20" >
                                                <el-steps class="executors" :key="loadTimer" :active="approvalInfo.approvalList.length" :align-center="approvalInfo.approvalList.length > 0">
                                                    <el-step v-for="(item, index) in approvalInfo.approvalList"  :key="index" align-center  @click.native="chooseApproveUser(index)">
                                                        <el-breadcrumb v-if="item && item.length > 0" slot="title" :separator="(approvalInfo.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                                            <el-breadcrumb-item  v-for="(user, i) in item" :key="i">{{user.trueName}}</el-breadcrumb-item>
                                                        </el-breadcrumb>
                                                    </el-step>
                                                    <el-step v-if="!this.approvalForm.approvalUserReadOnly" :key="approvalInfo.approvalList.length + 1" icon="el-icon-circle-plus-outline" @click.native="addApproval"></el-step>
                                                </el-steps>
                                                <el-steps class="executors-proportion" :key="renderTimer" :active="approvalInfo.approvalList.length" :align-center="approvalInfo.approvalList.length > 0">
                                                    <el-step v-for="(item, index) in approvalInfo.approvalList" :key="index" align-center>
                                                        <el-breadcrumb v-if="item && item.length > 0" slot="title">
                                                           <el-input-number v-model="approvalInfo.approvalUserGroupList[index].proportion" :precision="0" :step="1" :min="1" :max="100" v-if="approvalInfo.approvalUserGroupList[index].approvalMultiSignType == 2" placeholder="会签比例" @change="changeProportionVal(item)"></el-input-number>
                                                            <el-tooltip class="item" effect="dark" content="设置会签比例后当会签节点审批通过的人数达到了会签比例数则此审批节点直接通过,不配置则代表会签节点审批人员全部通过后节点状态才算通过,设置数字的单位为百分比,比例最大值为100就是代表百分之一百" placement="top-end">
                                                               <i class="el-icon-question" v-if="approvalInfo.approvalUserGroupList[index].approvalMultiSignType == 2"></i>
                                                            </el-tooltip>
                                                        </el-breadcrumb>
                                                    </el-step>
                                                </el-steps>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                    <el-form-item v-if="approvalInfo.approvalMethod == 1" label="审批流">
                                      <el-steps v-if="totalNum>0" :active="totalNum" align-center>
                                        <el-step v-for="(item, index) in selectUsers" :key="index">
                                            <el-breadcrumb slot="title" separator="/">
                                                <el-breadcrumb-item >{{item}}</el-breadcrumb-item>
                                            </el-breadcrumb>
                                        </el-step>
                                      </el-steps>
                                    </el-form-item>
                                </el-row>
                                <el-row>
                                  <!-- <template v-if="btnMode<2 && !isRead">
                                    <el-form-item label="审批流">
                                      <el-steps v-if="totalNum>0" :active="totalNum" align-center>
                                        <el-step v-for="(item, index) in selectUsers" :key="index" :title="item"></el-step>
                                      </el-steps>
                                    </el-form-item>
                                  </template> -->
                                  <template v-if="btnMode>=1 && !isRough">
                                      <el-collapse style="margin-left:3%" v-model="approvalRecordActiveName" @change="handleChangeCollapse4" accordion>
                                        <el-collapse-item name="approvalRecordItem">
                                            <template slot="title">
                                              <!-- <i class="header-icon el-icon-s-tools"></i> -->
                                              <span style="color: #606266;font-size: 14px" >审批记录</span>
                                            </template>
                                          <div>
                                            <el-table :data="approvalUserList" :border="true" height="180" style="margin-top:0px">
                                              <el-table-column
                                                type="index"
                                                width="50">
                                              </el-table-column>
                                                <el-table-column
                                                  label="审批人"
                                                  prop="trueName"
                                                  :show-overflow-tooltip="true"
                                                  align="center"
                                                  width="180">
                                                </el-table-column>
                                                <el-table-column
                                                  label="审批状态"
                                                  align="center"
                                                  width="180">
                                                  <template slot-scope="scope">
                                                      <el-button size="mini" type="info" v-if="scope.row.approvalResult==0" round>未处理</el-button>
                                                      <el-button size="mini" type="success" v-if="scope.row.approvalResult==1" round>通过</el-button>
                                                      <el-button size="mini" type="danger"  v-if="scope.row.approvalResult==2" round>驳回</el-button>
                                                      <el-button size="mini" type="warning"  v-if="scope.row.approvalResult==4" round>终止</el-button>
                                                    </template>
                                                </el-table-column>
                                                  <el-table-column
                                                    label="审批时间"
                                                    align="center"
                                                    sortable
                                                    prop="approvalDate"
                                                    width="200">
                                                </el-table-column>
                                                  <el-table-column
                                                    label="审批意见"
                                                    align="center"
                                                    :show-overflow-tooltip="true"
                                                    prop="approvalRemarks"
                                                    >
                                                </el-table-column>
                                              </el-table>
                                          </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                  </template>
                                </el-row>
                                <!-- 发起审批是的抄送人 -->
                                 <el-row v-if="btnMode===0||btnMode===3">
                                    <!-- <el-form-item label="会签人员" >
                                        <div class="executors">
                                            <div class="select-executor">
                                                <span v-for="(user, index) in countersignUsers" :key="user.userId" class="executor-item">
                                                    {{user.userName}}
                                                    <i class="executor-del el-icon-circle-close" @click.stop="handleDeleteUser(index)" title="取消会签人"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </el-form-item> -->
                                    <el-form-item label="抄送人员" >
                                        <!-- <el-tooltip :disabled="!selectedCopyUser.selectedUserNames" :content="selectedCopyUser.selectedUserNames" effect="light" placement="top">
                                            <el-input readonly v-model="selectedCopyUser.selectedUserNames" @focus="chooseCopyUser" ></el-input>
                                        </el-tooltip> -->
                                        <el-tag v-for="(item,index) in copyUserObj" :key="index" style="margin-left:4px;" closable @close="handleClose(item)">{{item.trueName}}</el-tag>
                                        <el-button size="mini" icon="el-icon-circle-plus-outline" title="添加抄送人员" circle @click.stop="addCopyFieldUser()"></el-button>
                                        <!-- <el-dropdown @command="handleCommand">
                                            <el-button>
                                            添加抄送人员<i class="el-icon-arrow-down el-icon--right"></i>
                                            </el-button>
                                            <el-dropdown-menu  split-button slot="dropdown">
                                            <el-dropdown-item command="1">人员列表</el-dropdown-item>
                                            <el-dropdown-item command="2">表单字段</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown> -->
                                    </el-form-item>
                                </el-row>
                                <el-row v-if="btnMode>0 && btnMode!=3">
                                    <el-form-item label="已发抄送人" >
                                         <el-tag v-for="(item,index) in copyUserObj" :key="index" style="margin-left:4px;">{{item.trueName}}</el-tag>
                                         <!-- <el-button size="mini" icon="el-icon-circle-plus-outline" title="添加抄送人员" circle @click.stop="addCopyFieldUser()"></el-button> -->
                                        <!-- <el-input disabled v-model="hasSelectedCopyUser.selectedUserNames" ></el-input> -->
                                    </el-form-item>
                                </el-row>
                                <el-row>
                                  <el-col :span="8">
                                    <el-form-item label="申请描述" >
                                        <el-input placeholder="请输入内容" :disabled="isRead"    type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="approvalForm.remarks"></el-input>
                                    </el-form-item>
                                  </el-col>
                                  <template v-if="btnMode<2 && isRead">
                                    <el-col :span="8">
                                      <el-form-item label="审批意见"
                                        prop="approvalRemarks"
                                        :rules="[
                                          { required: true, message: '请输入审批意见', trigger: 'blur' },
                                        ]"
                                      >
                                        <el-input :class="approvalRemarksStyle" placeholder="请输入审批意见"   type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="approvalForm.approvalRemarks"></el-input>
                                      </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                      <!-- <el-row v-if="isShowCopyUser"> -->
                                      <el-form-item label="抄送人员" >
                                            <el-tag v-for="(item,index) in copyUserObjTwo" :key="index" style="margin-left:4px;">{{item.trueName}}</el-tag>
                                            <el-button size="mini" icon="el-icon-circle-plus-outline" title="添加抄送人员" circle @click.stop="addNewCopyFieldUser()"></el-button>
                                        </el-form-item>
                                    </el-col>
                                  </template>
                                </el-row>
                              </div>
                            </el-collapse-item>
                          </el-collapse>
                          <el-row>
                              <!-- style="height:365px;overflow-y: auto"  -->
                              <el-form size="mini" v-show="false" ref="approvalForms"  label-width="165px">
                                    <el-form-item style="font-weight: 700;margin-left: -97px;" label="表单信息" >
                                          <el-collapse class="process-detail-Forms" style="" v-if="isShowForm" v-model="collapseActiveName" @change="handleChangeCollapse3" accordion>
                                            <el-collapse-item v-for="(form, index) in forms" :key="form.id" :title="form.formName" :name="form.id">
                                                  <template slot="title">
                                                      <div class='el-collapse-title'>
                                                       <i class="header-icon el-icon-document">【{{form.formName}}】</i>
                                                      </div>
                                                  </template>
                                                  <el-form  :model="formData[index].values" :key="loadTimerField" :ref="'customForm'+index" label-width="165px" :id="`print${form.id}`">
                                                      <!--模式1 -->
                                                      <!-- <FieldItem v-for="(field,index2) in form.fieldsList"
                                                        :findex="index2"
                                                        :ref="'fieldItemChild'+index2"
                                                        :formId="form.id"
                                                        :key="field.fieldId"
                                                        :field="field"
                                                        :formData="formData[index].values"
                                                        :colSpan="form.colSpan"
                                                        :isRead="isRead&&!((!field.approveFieldAuth||field.approveFieldAuth=='1')&&(approvalStatus==20||approvalStatus==23)&&btnMode==1)"
                                                        :approvalUserList="approvalUserList"
                                                        :processModelFormsObj="processModelFormsObj"
                                                        :isBelongApproval="true"
                                                        :fieldsList="form.fieldsList"
                                                         @loadLinkData="loadLinkData"
                                                         @refreshViewField="refreshViewField"
                                                        v-if="!field.formFieldAuth||field.formFieldAuth=='1'"
                                                      /> -->

                                                        <!-- 模式3  -->
                                                        <template v-for="(field,index2) in form.fieldsList" >
                                                          <template v-if="isShowNormalField(field,index,formData[index])">
                                                              <FieldItem
                                                                  :findex="index2"
                                                                  :formIndex="index"
                                                                  :ref="'fieldItemChild'+index2"
                                                                  :formId="form.id"
                                                                  :formConfig="form"
                                                                  :key="field.fieldId"
                                                                  :field="field"
                                                                  :formData="formData[index].values"
                                                                  :colSpan="form.colSpan"
                                                                  :isRead="isRead&&!((!field.approveFieldAuth||field.approveFieldAuth=='1')&&(approvalStatus==20||approvalStatus==23)&&btnMode==1)"
                                                                  :approvalUserList="approvalUserList"
                                                                  :processModelFormsObj="processModelFormsObj"
                                                                  :isBelongApproval="true"
                                                                  :fieldsList="form.fieldsList"
                                                                  @loadLinkData="loadLinkData"
                                                                  @refreshViewField="refreshViewField"
                                                                  @asynMainFormData="asynMainFormData"
                                                                  v-if="!field.formFieldAuth||field.formFieldAuth=='1'"
                                                                />
                                                          </template>
                                                        </template>
                                                        <div class="render-form-item" style="width: 100%; float: left;" v-if="(formData[index].values['subFormViewMode']!==0 && formData[index].ext1===1) || (formData[index].values['subFormViewMode'] && (formData[index].values['subFormViewMode'] > 0))">
                                                          <el-row>
                                                            <el-form-item label="" style="width: 100%;">
                                                              <el-tabs :key="loadTimerField" v-model="defaultViewOrder" >
                                                                  <template v-for="(field,index2) in form.fieldsList" >
                                                                    <template v-if="field.type === 'subform' && isShowCascadeField(field, formData[index].values)" >
                                                                      <el-tab-pane  :key="index2" :label="getSubformName(formData[index].values,field)" :name="index2+''">
                                                                          <FieldItem
                                                                            :findex="index2"
                                                                            :ref="'fieldItemChild'+index2"
                                                                            :formId="form.id"
                                                                            :formConfig="form"
                                                                            :key="field.fieldId"
                                                                            :field="field"
                                                                            :formData="formData[index].values"
                                                                            :colSpan="form.colSpan"
                                                                            :isRead="isRead&&!((!field.approveFieldAuth||field.approveFieldAuth=='1')&&(approvalStatus==20||approvalStatus==23)&&btnMode==1)"
                                                                            :approvalUserList="approvalUserList"
                                                                            :processModelFormsObj="processModelFormsObj"
                                                                            :isBelongApproval="true"
                                                                            :fieldsList="form.fieldsList"
                                                                             :subFormViewMode="1"
                                                                            @loadLinkData="loadLinkData"
                                                                            @refreshViewField="refreshViewField"
                                                                            v-if="!field.formFieldAuth||field.formFieldAuth=='1'"
                                                                          />
                                                                      </el-tab-pane>
                                                                    </template>
                                                                  </template>
                                                              </el-tabs>
                                                            </el-form-item>
                                                          </el-row>
                                                        </div>
                                                  </el-form>
                                              </el-collapse-item>
                                          </el-collapse>
                                      </el-form-item>
                                </el-form>
                            </el-row>
                     </el-form>
                  </el-tab-pane>
                  <!-- 文件列表 -->
                  <el-tab-pane name="third" label="文件列表">
                      <ApprovalFiles
                        ref="processFiles"
                        bizType="approval"
                        :processInstanceId="instances.id"
                        :approvalInstanceStatus="approvalTemplateObj.approvalStatus"
                        :templateId="instances.archiveTemplateId"
                        :busiProcessInstanceId="busiProcessInstanceId"
                        :busiTaskInstanceId="busiTaskInstanceId"
                        :belongProcessFlag="belongProcessFlag"
                        :isShowArchive="false"
                        :isCouldUpload="isCouldUploadFile"
                        :isCouldDelete="isCouldDeleteFile"/>
                  </el-tab-pane>
                  <!-- 沟通列表 -->
                  <el-tab-pane name="fouth" label="沟通留言">
                      <Comment
                        style="height:560px;"
                        class="comments"
                        :list="commentList"
                        :isMsgToUsers="true"
                        @commentAdd="handleCommentAdd"
                        @commentDelete="handleCommentDelete"
                        @commentSend="chooseCommentUser"
                      />
                  </el-tab-pane>
              </el-tabs>
        </div>
        <el-dialog
            title="文件上传"
            :visible.sync="isShowUpload">
            <ApprovalFiles ref="fileInstance"  bizType="process" :processInstanceId="this.instances.id" @importComplete="handleFileSearch" />
        </el-dialog>
         <el-dialog
            title="选择审批人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowUserOrg"
            append-to-body
          >
          <UserOrg ref="userOrgExt" :key="loadTimer" :multiple="true" :selectedUser="selectedUser" :canDrop="true"/>
          <span slot="footer" class="dialog-footer">
              <el-button v-if="approvalInfo.approvalMethod == 2" type="primary" @click="confirmClick(1)">确定或签</el-button>
              <el-button v-if="approvalInfo.approvalMethod == 2" type="primary" @click="confirmClick(2)">确定会签</el-button>
              <el-button v-if="approvalInfo.approvalMethod != 2" type="primary" @click="confirmClick()">确定</el-button>
              <el-button @click="isShowUserOrg = false">取 消</el-button>
              <el-button v-if="approvalInfo.approvalMethod == 2" type="danger" @click="handleDeleteNode">删除当前节点</el-button>
          </span>
        </el-dialog>
         <el-dialog
            title="选择抄送人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowCopyUserOrg"
            append-to-body
          >
            <UserOrg ref="userOrgExtCopy" :multiple="true" :selectedUser="selectedCopyUser" :canDrop="true"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowCopyUserOrg = false">取 消</el-button>
                <el-button type="primary" @click="confirmCopyUserClick">确 定</el-button>
            </span>
        </el-dialog>
         <el-dialog
            title="选择所属流程"
            :visible.sync="isShowProcessListDialog"
            append-to-body
            width = "60%">
            <ProcessPop  :field="{}" ref="processSelect" :formData="{}" @nodeClick="selectTrigger"/>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="isShowProcessListDialog = false" >取 消</el-button> -->
                <el-button  type="primary" @click="handleClickOk">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="选择待发送人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowCommentUserOrg"
            append-to-body
          >
          <UserOrg ref="userOrgExtComment" :multiple="true" :selectedUser="selectedCommentUser" :canDrop="true"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowCommentUserOrg = false">取 消</el-button>
              <el-button type="primary" @click="confirmCommontClick">确定发送</el-button>
          </span>
        </el-dialog>
        <el-dialog
            title="审批流实例人员选择"
            :visible.sync="isShowHisApprovalDialog"
            append-to-body
            width = "80%">
            <ApprovalInstanceSelectPop :key="loadTimer" ref="approvalInstanceSelectPop" :approvalTemplateId="approvalTemplateObj.id" :approvalStatus="12" @cancel="hisApprovalSelectCancel" @confirm="hisApprovalSelectConfirm" />
        </el-dialog>
        <el-dialog
            title="选择抄送人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowCopyFieldUserOrg"
            v-if="isShowCopyFieldUserOrg"
            append-to-body
          >
          <UserOrg  :key="loadTimer" ref="copyFieldUserOrg" :multiple="true" :selectedUser="selectedCopyFieldUser" :canDrop="true" />
          <span slot="footer" class="dialog-footer">
              <el-button  type="primary" @click="confirmCopyFieldUserOrg()">确定</el-button>
              <el-button @click="isShowCopyFieldUserOrg = false">取 消</el-button>
          </span>
        </el-dialog>
        <el-dialog
            title="设置审批节点"
            top="4vh"
            width="75%"
            :visible.sync="isShowApproveSetNode"
			v-if="isShowApproveSetNode"
            custom-class="approveSetNode"
            append-to-body
          >
          <ApprovePeopleRule  :forms="forms"  @saveApproveRule="saveApproveRule" :approvePeopleArray="approvePeopleItemArray" :singleNode="true"></ApprovePeopleRule>
        </el-dialog>

        <FieldValidation  ref="fieldValidation"/>
        <iframe :src="fileDownloadUrl" width="0" height="0" frameborder="0" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Comment from '@/pages/process/components/Comment';
    import ProcessDiagram from '@/pages/process/MyProcess/ProcessDiagram';
    import RelateFormList from '@/pages/business/BusinessApplication/RelateFormList.vue';
    import ApprovalFiles from '@/components/ApprovalFiles';
    import FieldValidation from '@/components/Formula/FieldValidation.vue';
    import ApprovePeopleRule from '@/pages/process/ProcessTemplate/ApprovePeopleRule';
    import { isEmpty, clone, cloneDeep } from 'lodash';
    import { API_FILE_DOWNLOAD } from '@/common/constants';
    import { getFormConfigs,
        saveApprovalInstance,
        getApprovalRecordList,
        getArchiveTemplateTreeList,
        getProcessInstancesRecordList,
        getProcessInstanceFiles,
        getProcessInstancesCommentList,
        saveProcessInstancesComment,
        delProcessFile,
        delTaskFile,
        deleteProcessInstancesComment,
        getAllUserTask,
        sendApprovalCommentMsg,
        getSerialNumber,
        getSerialNumberDepAndOption,
        getSerialNumberDepartment,
        downloadFiles,
        getModelFormDetail,
        checkDataLegitimacy,
        upDateSerialNumberState,
        getSerialNumberPlus,
        getFormConfig,
        getModelFormReportList
    } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import ProcessPop from '@/components/ProcessPop';
    import { isFormFieldVisible, isRequiredFormFieldVisible, resetCascadeFieldVisible } from '@/utils/form-required';

    export default {
        mixins: [ mixinsNav ],
        components: {
            ProcessDiagram,
            Comment,
            ProcessPop,
            ApprovalFiles,
            FieldValidation,
            RelateFormList,
            ApprovePeopleRule
        },
        data () {
            return {
                defaultApprovePeopleList: [], // 默认审批流人list
                mainId: '',
                tempFormData: [], // 将要新增的关联表单数据
                showRelateFormTab: false,
                relateFormTabName: '',
                loadTimerRelate: new Date().getTime(),
                relateModelList: [], // 关联的表单
                forms: [],
                isShowHisApprovalDialog: false,
                approvalFormLoadTimer: '',
                loadTimer: new Date().getTime(),
                loadTimerField: new Date().getTime(),
                approvalUserListLoader: '',
                currentIndex: 0, // 当前点击节点
                isProcessShare: 0, // 是否共享给流程
                hasSelectedCopyUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                approvalRemarksStyle: '',
                approvalBaseActiveName: '',
                approvalRecordActiveName: 'approvalRecordItem',
                approvalUserActiveName: '',
                approvalSettingActiveName: '',
                isShowProcessListDialog: false,
                isShowCopyUserOrg: false,
                selectCopyUsers: [],
                selectedCopyUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                selectedCopyFieldUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowUserOrg: false,
                approvalUserList: [],
                totalNum: 0,
                selectUsers: [],
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowForm: false,
                formInfo: {},
                collapseActiveName: '',
                lastCollapseActiveName: '',
                isShowSaveBtn: false,
                orderBy: false, // 流程执行记录按时间排序 0现在到开始 1从开始到现在
                tabName: 'first',
                tabPosition: 'top',
                filePage: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                filesList: [],
                fileDownloadUrl: '',
                isShowUpload: false,
                isShowDiagram: false,
                isShowForms: false,
                isShowSetting: false,
                recordList: [],
                commentList: [],
                processInfo: {},
                active: false, // 是否显示侧滑弹窗
                searchFileParams: {
                    fileName: '',
                    processInstanceId: '',
                    currentPage: 1, // 当前页码
                    pageSize: 10 // 每页条数
                },
                taskList: [],
                rootPath: '/process/myProcess/:processInstanceId',
                subInstances: {},
                isShowSubDiagram: false,
                subTaskList: [],
                formData: [],
                searchParams: {},
                approvalForm: {
                    approvalName: '',
                    approvalRemarks: '',
                    selectedUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    selectedCopyUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    remarks: '',
                    sendSms: 0,
                    nameReadOnly: false,
                    approvalUserReadOnly: false,
                    durTime: 0,
                    warnDate: '',
                    orderMode: 1,
                    rejectMode: 0
                },
                countersignUsers: [],
                isShowCommentUserOrg: false,
                msgComment: {},
                selectedCommentUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isCouldUploadFile: true,
                isCouldDeleteFile: true,
                defaultViewOrder: null,
                isShowApproveSetNode: false,
                approvePeopleItemArray: [],
                renderTimer: '',
                copyUserObj: [],
                copyUserObjTwo: [],
                isShowCopyFieldUserOrg: false,
                draftFixed: false,
                searchParamsField: {
                    modelId: '',
                    name: '',
                    selectedFields: '',
                    searchCondition: []
                },
                searchCondition: [],
                defaultConditonsMap: new Map(), // 默认设置关联数据的过滤条件map
                searchConditionExt: []
            };
        },
        computed: {
            ...mapGetters([
                'userInfo'
            ])
        },
        watch: {
            'relateModelList' (newVal, oldVal) {
                if (newVal && newVal.length > 0) {
                    for (let i = 0; i < newVal.length; i++) {
                        let cur = newVal[i];
                        if (oldVal && oldVal.length > 0) {
                            let res = oldVal.find(element => element.id === cur.id);
                            if (res.hiddenElement) {
                                cur.hiddenElement = res.hiddenElement;
                            } else {
                                cur.hiddenElement = false;
                            }
                        }
                    }
                }
                for (let i = 0; i < this.relateModelList.length; i++) {
                    let cur = this.relateModelList[i];
                    if (!cur.hiddenElement) {
                        this.relateFormTabName = cur.id;
                        break;
                    }
                }
            }
        },
        props: {
            formDataFromBusiness: {// 来自业务中心表单数据
                type: Object
            },
            isRough: {// 是否是草稿
                type: Boolean,
                default: false
            },
            isInstance: {
                type: Boolean,
                default: false
            },
            instances: {
                type: Object,
                default: function () {
                    return {
                        id: '',
                        formObj: {
                        }
                    };
                }
            },
            approvalInfo: {
                type: Object,
                default: function () {
                    return {
                        templateId: '',
                        processInstanceId: '',
                        deploymentId: '',
                        approvalName: '',
                        approvalTotalNum: 0,
                        orderMode: 1,
                        rejectMode: 0,
                        approvalTypeName: '',
                        approvalType: '',
                        remarks: '',
                        approvalRemarks: '',
                        selectedUserIds: '',
                        selectedUserNames: '',
                        selectedCopyUserIds: '',
                        selectedCopyUserNames: '',
                        processInstanceName: '',
                        sendSms: 0,
                        durTime: 0,
                        warnDate: '',
                        isProcessShare: 0,
                        approvalStatus: 0,
                        approvePeopleLists: []
                    };
                }
            },
            approvalTemplateObj: {
                type: Object
            },
            isFinish: {
                type: Boolean,
                default: false
            },
            isRead: {
                type: Boolean,
                default: false
            },
            btnMode: {
                type: Number,
                default: 0
            },
            busiProcessInstanceId: {
                type: String
            },
            busiProcessInstanceName: {
                type: String
            },
            busiTaskInstanceId: {
                type: String
            },
            belongProcessFlag: {// 0 其他 1流程 2任务
                type: Number,
                default: 0
            },
            isShowCopyUser: {
                type: Boolean,
                default: false
            },
            taskParam: {// 任务对象,用于暂存
                type: Object
            },
            processModelFormsObj: {
                type: Array
            },
            approvalStatus: {
                type: Number
            },
            isDraft: {
                type: Boolean,
                default: false
            }
        },
        mounted () {
            this.$nextTick(() => {
                if (!isEmpty(this.forms)) {
                    // console.log(this.forms);
                    let formInfo = this.forms[0];// 默认第一个
                    if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                        resetCascadeFieldVisible(formInfo.fieldsList, this.formData[0].values);
                        this.loadTimerField = new Date().getTime();
                        let initUserArr = [];
                        for (var i = 0; i < formInfo.fieldsList.length; i++) {
                            let tempField = formInfo.fieldsList[i];
                            let tempRefName = 'fieldItemChild' + i;
                            if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                                setTimeout(() => {
                                // 设置下拉字段级联默认显示数据
                                    if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                        this.$refs[tempRefName][0].initDefaultCasData();
                                    }
                                }, 0);
                            }
                            if (!this.defaultViewOrder && tempField.type === 'subform') { // 用来显示默认第一个子表单
                                this.defaultViewOrder = i + '';
                            }
                            if (tempField.type === 'user') {
                                initUserArr.push(tempRefName);
                            }
                        }
                        for (var j = 0; j < initUserArr.length; j++) { // 针对人员级联初始化
                            let tempRefName = initUserArr[j];
                            setTimeout(async () => {
                                // 设置下拉字段级联默认显示数据
                                if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                    await this.$refs[tempRefName][0].setUserExtCascadeData(true);
                                }
                            }, 0);
                        }
                    }
                }
            });
        },
        created () {
            if (this.isDraft || this.isRead) {
                this.draftFixed = true;
            }
            // console.log(this.approvalTemplateObj);
            // console.log(this.approvalTemplateObj.tempFormData);// 新增的关联子表数据
            // console.log(this.approvalInfo);
            // console.log(this.approvalInfo.approvalMethod);
            // this._initPage();
            if (this.approvalInfo.mainModelInfo) {
                this.approvalTemplateObj.mainModelInfo = this.approvalInfo.mainModelInfo;
            }
        },
        methods: {
            async _initPage () {
                // this.getRecordList();
                this._initFormData(); // 等初始化方法执行完后再执行后续表单初始化方法
                // await this._initFormData().then(val => { // 等初始化方法执行完后再执行后续表单初始化方法
                //     this.initDefaultFormSetting();// 初始化表单级联相关配置
                // });
                this.getCommentList();
            },
            chkFormulaMode () { // 判断是否后计算表单，假如是则用应用表单的数据来覆盖填充当前表单,返回表单下标
                let isFind = false;
                let index = null;
                for (let i = 0; i < this.forms.length; i++) {
                    let element = this.forms[i];
                    let fieldsList = element.fieldsList;
                    for (let j = 0, len = fieldsList.length; j < len; j++) {
                        let field = fieldsList[j];
                        if (field.type === 'calculation' && field.options.formulaExp !== undefined && ((field.options.formulaExp.indexOf(';') !== -1) || (field.options.formulaExp.indexOf(',') !== -1))) {
                            isFind = true;
                            break;
                        }
                    };
                    if (isFind) {
                        index = i;
                        break;
                    }
                }
                return isFind ? this.forms[index].id : null;
            },
            async _initFormData () {
                this.selectFormIndex = 0;
                this.formData.length = 0;
                this.formData = [];
                this.forms = [];
                this.isShowForm = false;
                if (!this.isInstance) {
                    await this.initStruct();
                } else {
                    this.forms = this.instances.formObj.structure;
                }
                let objTemporaryData = await this._getTemporaryFormData();
                if (objTemporaryData && Array.isArray(objTemporaryData)) {
                    let formMap = new Map();
                    this.formData = [];
                    this.forms.forEach(element => {
                        let isMatch = false;
                        objTemporaryData.forEach(form => {
                            if (element.id === form.formId) {
                                this.formData.push(form);
                                formMap.set(form.formId, form);
                                isMatch = true;
                            }
                        });
                        if (!isMatch) {
                            this.renderdefaultForm(element);
                        }
                        if (this.approvalStatus === 20 || this.approvalStatus === 13 || this.approvalStatus === 10 || this.approvalStatus === 23) {
                            let fieldsList = element.fieldsList;
                            for (let index = 0; index < fieldsList.length; index++) {
                                const element = fieldsList[index];
                                let ext2 = element.options.ext2;
                                if (ext2) {
                                    let curObj = JSON.parse(ext2);
                                    if (this.approvalStatus === 13 || this.approvalStatus === 10) { // 审核页面要看全部的字段此处注释掉表单权限过滤
                                        element.formFieldAuth = curObj.formFieldAuth;
                                    }
                                    if (curObj.formFieldAuthRange && curObj.formFieldAuthRange === 1) { // 查看权限在申请及审核阶段都生效
                                        element.formFieldAuth = curObj.formFieldAuth;
                                    }
                                    element.approveFieldAuth = curObj.approveFieldAuth;
                                } else {
                                    element.approveFieldAuth = '0';
                                }
                            };
                        }
                    });
                    this.forms = this.instances.formObj.structure;
                } else {
                    this.forms.forEach(element => {
                        this.renderdefaultForm(element);
                    });
                }
                if (this.forms && this.forms.length > 0) {
                    this.collapseActiveName = this.forms[0].id;// 默认打开第一个表单
                }
                this.approvalBaseActiveName = 'approvalBaseItem';
                if (this.btnMode === 1) {
                    await this.getApprovalUserList();
                    this.approvalRemarksStyle = 'approvalRemarksStyle';
                    this.approvalBaseActiveName = 'approvalBaseItem';
                } else {
                    this.approvalRemarksStyle = '';
                }
                if (this.btnMode === 2) { // 查看审批记录
                    await this.getApprovalUserList();
                    this.handleChangeCollapse4();// 打开审批记录页签
                }
                // console.log('============================');
                // console.log(this.forms);
                this.approvalFormLoadTimer = new Date().getTime();
                this.isShowForm = true;
                this.approvalInfo.remarks = this.approvalTemplateObj.remarks;
                this.approvalInfo.approvalTotalNum = isEmpty(this.approvalTemplateObj.approvalTotalNum) ? 0 : this.approvalTemplateObj.approvalTotalNum;
                if (this.btnMode === 0) {
                    this.approvalInfo.approvalName = '';
                } else {
                    this.approvalInfo.approvalName = this.approvalTemplateObj.templateName;
                    this.approvalForm.approvalName = this.approvalInfo.approvalName;
                }

                this.approvalInfo.approvalType = this.approvalTemplateObj.busiType;
                this.approvalInfo.approvalTypeName = this.approvalTemplateObj.busiTypeName;
                // this.approvalInfo.approvalTotalNum = this.approvalTemplateObj.approvalTotalNum;

                this.approvalInfo.selectedUserIds = this.approvalTemplateObj.selectedUserIds;
                this.approvalInfo.selectedUserNames = this.approvalTemplateObj.selectedUserNames;
                this.approvalForm.selectedUser = this.approvalTemplateObj.selectedUser;
                this.approvalInfo.busiProcessInstanceId = this.approvalTemplateObj.busiProcessInstanceId;
                this.approvalInfo.busiProcessInstanceName = isEmpty(this.busiProcessInstanceName) ? this.approvalTemplateObj.busiProcessInstanceName : this.busiProcessInstanceName;
                // this.approvalInfo.orderMode = (this.approvalTemplateObj.orderMode === undefined || this.approvalTemplateObj.orderMode == null || this.approvalTemplateObj.orderMode === '') ? 0 : this.approvalTemplateObj.orderMode;// 默认为自由模式
                this.approvalInfo.orderMode = 1;// 默认为固定模式
                this.approvalInfo.rejectMode = (this.approvalTemplateObj.rejectMode === undefined || this.approvalTemplateObj.rejectMode == null || this.approvalTemplateObj.rejectMode === '') ? 0 : this.approvalTemplateObj.rejectMode;
                this.approvalInfo.sendSms = this.approvalTemplateObj.sendSms;
                this.approvalInfo.durTime = this.approvalTemplateObj.durTime;
                this.approvalInfo.warnDate = this.approvalTemplateObj.warnDate;
                this.approvalForm.nameReadOnly = this.approvalTemplateObj.nameReadOnly;
                this.approvalInfo.nameReadOnly = this.approvalTemplateObj.nameReadOnly;
                this.approvalForm.approvalUserReadOnly = this.approvalTemplateObj.approvalUserReadOnly;
                this.approvalInfo.approvalUserReadOnly = this.approvalTemplateObj.approvalUserReadOnly;
                if (this.approvalTemplateObj.approvalList) {
                    this.approvalInfo.approvalList = cloneDeep(this.approvalTemplateObj.approvalList);
                }
                if (this.approvalTemplateObj.approvalUserGroupList) {
                    this.approvalInfo.approvalUserGroupList = cloneDeep(this.approvalTemplateObj.approvalUserGroupList);
                }
                if (this.approvalTemplateObj.showAllMyApprovals) {
                    this.approvalInfo.showAllMyApprovals = this.approvalTemplateObj.showAllMyApprovals;
                }
                if (this.approvalTemplateObj.approvalMethod == 3 && this.approvalInfo.approvalList) {
                    let approvePeopleLists = [];
                    for (let i = 0; i < this.approvalInfo.approvalList.length; i++) {
                        let curObj = this.approvalInfo.approvalList[i];
                        let groupOrderObj = this.approvalInfo.approvalUserGroupList[i];
                        let item = {};
                        item.approveWay = groupOrderObj.approvalMultiSignType;
                        item.approveOrder = groupOrderObj.executionGroupOrder;
                        item.id = this.generateUUID();
                        let approvePeoples = [];
                        for (let j = 0; j < curObj.length; j++) {
                            let approveObj = curObj[j];
                            let curUser = {selectedUserName: approveObj.trueName, approvePeopleType: 'user', selectedUserId: approveObj.userId};
                            approvePeoples.push(curUser);
                        }
                        item.approvePeoples = approvePeoples;
                        approvePeopleLists.push(item);
                    }
                    this.approvalInfo.approvePeopleList = approvePeopleLists;
                    this.defaultApprovePeopleList = approvePeopleLists;
                }
                if (this.approvalTemplateObj.approvalMethod) {
                    this.approvalInfo.approvalMethod = this.approvalTemplateObj.approvalMethod;
                }
                // 发起时的默认抄送人
                // console.log(this.btnMode, this.selectedCopyUser, this.hasSelectedCopyUser);
                if (this.btnMode === 0 || this.btnMode === 3) { // 发起时选择抄送人
                    this.approvalInfo.selectedCopyUserIds = this.approvalTemplateObj.copyUserIds;
                    this.approvalInfo.selectedCopyUserNames = this.approvalTemplateObj.copyUserNames;
                    this.selectedCopyUser.selectedUserIds = this.approvalTemplateObj.copyUserIds;
                    this.selectedCopyUser.selectedUserNames = this.approvalTemplateObj.copyUserNames;
                    this.approvalForm.selectedCopyUser = this.selectedCopyUser;
                } else {
                    // 这两行好像只是为了展示抄送人
                    this.hasSelectedCopyUser.selectedUserIds = this.approvalTemplateObj.copyUserIds;
                    this.hasSelectedCopyUser.selectedUserNames = this.approvalTemplateObj.copyUserNames;
                    // 需要把默认的抄送人给用户
                    this.approvalInfo.selectedCopyUserIds = this.approvalTemplateObj.copyUserIds;
                    this.approvalInfo.selectedCopyUserNames = this.approvalTemplateObj.copyUserNames;
                }

                this.approvalForm.orderMode = this.approvalInfo.orderMode;// 默认为自由模式
                this.approvalForm.rejectMode = this.approvalInfo.rejectMode;
                this.approvalForm.sendSms = this.approvalInfo.sendSms;
                this.approvalForm.durTime = this.approvalInfo.durTime;
                this.approvalForm.warnDate = this.approvalInfo.warnDate;
                this.approvalForm.remarks = isEmpty(this.approvalInfo.remarks) ? '' : this.approvalInfo.remarks;

                this.selectedUser = this.approvalTemplateObj.selectedUser;
                this.selectUsers = [];
                this.totalNum = 0;
                if (!isEmpty(this.selectedUser.selectedUserNames)) {
                    this.selectUsers = this.selectedUser.selectedUserNames.split(',');
                    this.totalNum = this.selectUsers.length;
                }
                // 审批通过、审批驳回的审批详情文件列表不允许操作，
                if (this.approvalTemplateObj.approvalStatus === 2 || this.approvalTemplateObj.approvalStatus === 3) {
                    this.isCouldUploadFile = false;
                    this.isCouldDeleteFile = false;
                }
                // console.log(this.approvalTemplateObj);
                // 被驳回后再次发起审批时可以放开文件上传和删除按钮
                if (this.approvalTemplateObj.approvalStatus === 3 && this.approvalTemplateObj.parentApprovalId) {
                    this.isCouldUploadFile = true;
                    this.isCouldDeleteFile = true;
                }
                if (this.approvalTemplateObj.approvePeopleList) {
                    this.approvalInfo.approvePeopleList = this.approvalTemplateObj.approvePeopleList;
                    this.defaultApprovePeopleList = clone(this.approvalTemplateObj.approvePeopleList);
                }
                this.tabName = 'first';
                this.initApprovePeople();
                this.initDeptApprovePeople();
                this.getDefaultApproveName();
                // console.log(this.approvalTemplateObj);
                // 回显抄送人
                if (this.approvalTemplateObj.copyUserObj && this.approvalTemplateObj.copyUserObj.length > 5) {
                    this.copyUserObj = JSON.parse(this.approvalTemplateObj.copyUserObj);
                } else { // 以往的旧数据
                    if (this.approvalTemplateObj.copyUserIds && this.approvalTemplateObj.copyUserIds != '' && this.approvalTemplateObj.copyUserIds.length > 5) { //
                        let selectedUserIds = this.approvalTemplateObj.copyUserIds;
                        let selectedUserNames = this.approvalTemplateObj.copyUserNames;
                        let selectedUserNamesArray = selectedUserNames.split(',');
                        let selectedUserIdsArray = selectedUserIds.split(',');
                        for (let i = 0; i < selectedUserIdsArray.length; i++) {
                            let userId = selectedUserIdsArray[i];
                            let trueName = selectedUserNamesArray[i];
                            let item = {userId: userId, trueName: trueName};
                            item.id = this.generateUUID();
                            item.approvePeopleType = 'user';
                            this.copyUserObj.push(item);
                        }
                    }
                    // console.log(this.approvalTemplateObj.approvalStatus);
                    // console.log(this.approvalTemplateObj);
                    // console.log(this.copyUserObj);
                    // console.log(this.approvalInfo);
                }
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            async getApprovalUserList () {
                if (this.approvalTemplateObj.opType !== 2) {
                    this.searchParams.processInstanceId = this.approvalTemplateObj.oldProcessInstanceId ? this.approvalTemplateObj.oldProcessInstanceId : this.approvalTemplateObj.processInstanceId;
                    let approvalData = await getApprovalRecordList(Object.assign({}, {
                        currentPage: 1,
                        pageSize: 10
                    }, this.searchParams));

                    this.approvalUserList = approvalData.data;
                }
            },
            renderdefaultForm (element) {
                let fieldsList = element.fieldsList;
                let values = {};
                let attributes = {};
                for (let index = 0, len = fieldsList.length; index < len; index++) {
                    const element = fieldsList[index];
                    values[element.id] = '';
                    attributes[element.id] = element.type;
                    let ext2 = element.options.ext2;
                    if (ext2) {
                        let curObj = JSON.parse(ext2);
                        element.formFieldAuth = curObj.formFieldAuth;
                        element.approveFieldAuth = curObj.approveFieldAuth;
                    }
                };
                // 从应用中心表单详情直接发起审批的情况
                if (this.formDataFromBusiness && this.formDataFromBusiness.formId === element.id) {
                    this.formData.push(this.formDataFromBusiness);
                } else {
                    this.formData.push({
                        formId: element.id,
                        values: values,
                        attributes: attributes,
                        colSpan: element.colSpan ? element.colSpan : 1,
                        ext1: element.ext1 ? Number(element.ext1) : 0
                    });
                }
            },
            async _getTemporaryFormData () {
                let temporaryFormData;
                if (this.instances.formObj && this.instances.formObj.instance) {
                    try {
                        let formId = await this.chkFormulaMode();
                        let strTemporaryData;
                        if (formId) {
                            let oldInstances = JSON.parse(this.instances.formObj.instance);
                            for (let i = 0; i < oldInstances.length; i++) {
                                let form = oldInstances[i];
                                if (formId === form.formId) {
                                    let param = {instanceId: this.instances.id, formId: formId};
                                    let res = await getModelFormDetail(param);
                                    if (res) {
                                        oldInstances[i] = JSON.parse(res.formValues);
                                    }
                                }
                            };
                            temporaryFormData = oldInstances;
                        } else {
                            strTemporaryData = this.instances.formObj.instance;
                            let objTemporaryData = JSON.parse(strTemporaryData);
                            temporaryFormData = objTemporaryData;
                        }
                    } catch (error) {
                        console.error('解析暂存的任务表单数据异常：', error);
                    }
                }
                return temporaryFormData;
            },
            async initStruct () {
                let formIds = [];
                this.approvalTemplateObj.dataOperate.forms.forEach(element => {
                    formIds.push(element.formId);
                });
                let formsMap = await getFormConfigs(formIds.join(','));
                this.instances.formObj = {};
                this.instances.formObj.structure = [];
                for (var key in formsMap) {
                    if (formsMap[key]) {
                        this.instances.formObj.structure.push(formsMap[key]);
                    }
                }
                this.forms = this.instances.formObj.structure;
            },
            handelShowTable () { // 列表模式
                this.isShowArchiveTemplate = false;
                this.isShowArchiveTable = true;
                setTimeout(() => { // 默认回显值
                    this.$refs.archiveTable._initPage();
                }, 0);
            },
            handelShowDisk () { // 云盘模式
                this.isShowArchiveTemplate = true;
                this.isShowArchiveTable = false;
                setTimeout(() => { // 默认回显值
                    this.$refs.archiveTemplate._initPage();
                }, 0);
            },
            _getIconClass (recordType) {
                let strClass = 'el-icon-location';// 事件
                if (recordType === 0) {

                } else if (recordType === 1) { // 任务
                    strClass = 'el-icon-setting';
                } else if (recordType === 2) { // 网关
                    strClass = 'el-icon-share';
                } else if (recordType === 3) { // 子流程
                    strClass = 'el-icon-d-caret';
                } else if (recordType === 4) { // 嵌套子流程
                    strClass = 'el-icon-news';
                }
                return strClass;
            },
            async getRecordList () {
                if (this.instances) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.recordList = await getProcessInstancesRecordList(this.instances.id, this.orderBy ? 1 : 0);
                    loading.close();
                    // console.log(this.recordList);
                }
            },
            async getCommentList () {
                if (this.instances) {
                    let { data } = await getProcessInstancesCommentList({
                        processInstanceId: this.instances.id
                    });
                    this.commentList = data;
                }
            },
            async handleFileSearch () {
                this.isShowUpload = false;
                if (this.instances) {
                    this.searchFileParams.processInstanceId = this.instances.id;
                    this.searchFileParams.currentPage = this.filePage.currentPage;
                    this.searchFileParams.pageSize = this.filePage.pageSize;
                    let formData = await getProcessInstanceFiles(this.searchFileParams);
                    this.filesList = formData.data;
                    this.filePage = {
                        currentPage: formData.currentPage,
                        pageSize: formData.pageSize,
                        totalPageNum: formData.totalPageNum
                    };
                }
            },
            async handleCommentAdd (comment) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await saveProcessInstancesComment({
                    processInstanceId: this.instances.id,
                    comments: comment.content,
                    texts: comment.text,
                    mainId: comment.mainId,
                    supId: comment.supId
                });
                await this.getCommentList();
                loading.close();
            },
            async handleCommentDelete (comment) {
                await deleteProcessInstancesComment(comment.id);
                await this.getCommentList();
            },
            async confirmCommontClick () {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$refs.userOrgExtComment.setChoosedUser();
                this.msgComment.supId = this.selectedCommentUser.selectedUserIds + ';' + this.selectedCommentUser.selectedUserNames;
                this.msgComment.mainId = this.approvalForm.approvalName;
                this.msgComment.isDelete = 1;// 1:审批流，2：流程，3：任务
                await sendApprovalCommentMsg(this.msgComment);
                loading.close();
                this.isShowCommentUserOrg = false;
            },
            chooseCommentUser (comment) {
                this.selectedCommentUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
                this.msgComment = comment;
                setTimeout(() => { // 初始化
                    this.$refs.userOrgExtComment._initPage();
                }, 0);
                this.isShowCommentUserOrg = true;
            },
            async handelShowDiagram () {
                await this.setProcessViewInfo();
                this.isShowDiagram = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.diagrams.setProcessState(this.isFinish);
                    this.$refs.diagrams.resetDiagramUrl();
                }, 0);
            },
            handelShowForms () {
                // console.log(this.instances);
                this.processInfo.serviceName = this.instances.processServiceName;
                this.processInfo.instanceName = this.instances.name;
                this.processInfo.processInstanceId = this.instances.id;
                this.processInfo.deploymentId = this.instances.deploymentId;
                this.isShowForms = true;
            },
            handelHideForms () {
                this.isShowForms = false;
            },
            // async handleViewComment () {
            //     await this.getCommentList();
            //     // console.log(this.commentList);
            //     if (this.active !== true) {
            //         this.active = true;
            //     }
            // },
            hideSidebox () {
                this.active = false;
            },
            async dataImport () {
                // const param = {};
                // param.modelId = this.selectedModel.id;
                // setTimeout(() => { // 调用子组件的方法
                //     this.$refs.fileInstance.initParam(param);
                // }, 0);
                this.isShowUpload = true;
            },
            handleDownload (fileobj) {
                // this.fileDownloadUrl = `${API_FILE_DOWNLOAD}${fileobj.filePath}`;
                let url = `${API_FILE_DOWNLOAD}${fileobj.filePath}`;
                this.download(url);
            },
            download (url) {
                // var iframe = document.createElement('iframe');
                // iframe.style.display = 'none';
                // iframe.src = url;
                // document.body.appendChild(iframe);
                downloadFiles(url);
            },
            handleFileDelete (fileobj) {
                let param = {
                    processInstanceId: this.instances.id,
                    taskInstanceId: fileobj.taskId ? fileobj.taskId : null,
                    fileId: fileobj.id
                };
                this.$confirm(`您确定要删除文件[ ${fileobj.fileName} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    if (fileobj.taskId) {
                        await delTaskFile(param);
                    } else {
                        await delProcessFile(param);
                    }
                    this.handleFileSearch();
                }).catch(() => {});
            },
            async handelProcessDetail () {
                await this.setProcessViewInfo();
                this.isShowSetting = true;
            },
            async setProcessViewInfo () {
                //  console.log(this.instances);
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let tasks = await getAllUserTask(this.instances.id, this.instances.processServiceId, null, this.instances.deploymentId);
                // console.log(tasks);
                this.taskList = tasks;
                let treeList = [];
                if (this.instances.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: this.instances.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                loading.close();
            },
            handleTabClick (tab, event) {
                this.isShowSaveBtn = false;
                if (tab.index === '4') {
                    this.isShowArchiveTemplate = false;
                    this.isShowArchiveTable = true;
                    setTimeout(() => { // 默认回显值
                        this.$refs.archiveTable._initPage();
                    }, 0);
                } else if (tab.index === '2' && this.forms.length > 0) {
                    this.isShowSaveBtn = true;
                    this.approvalFormLoadTimer = new Date().getTime();
                } else if (tab.index === '3') {
                    this.$refs.processFiles._initPage();
                } else if (tab.index === '0') {
                    this.getDefaultApproveName();
                    if (this.approvalInfo.approvalMethod == 3) { // 表单字段动态审批人，带出表单人员赋值到审批流上
                        this.initApprovePeople();
                    } else if (this.approvalInfo.approvalMethod === 1) {
                        this.initDeptApprovePeople();
                    }
                    // 带出抄送人员
                    if (this.copyUserObj && this.copyUserObj.length > 0) { // 说明有抄送人
                        this.copyUserObj.forEach(item => {
                            if (item.approvePeopleType === 'formField') { // 字段类型
                                for (let i = 0; i < this.formData.length; i++) {
                                    let cur = this.formData[i];
                                    let values = cur.values;
                                    item.trueName = values[item.id + '-user'];
                                    item.userId = values[item.id];
                                }
                            }
                        });
                    }
                }
            },
            async changeSwitch () {
                await this.getRecordList();
            },
            handlePrint (index) {
                this.$print(this.$refs['customForm' + index]);
            },
            checkFormValid (flag, ret) { // 0同意1驳回
                if (flag === 0) {
                    if (isEmpty(this.approvalForm.approvalRemarks)) {
                        // 如果审批意见未填写，默认为同意
                        this.approvalForm.approvalRemarks = '同意';
                    }
                } else if (flag === 1) {
                    if (isEmpty(this.approvalForm.approvalRemarks)) {
                        // 如果审批意见未填写，默认为驳回
                        this.approvalForm.approvalRemarks = '驳回';
                    }
                }
                // console.log(flag+"============="+this.approvalForm.approvalRemarks);
                let isNotValid = false;
                this.$refs['approvalForm'].validate((valid) => {
                    if (!valid) {
                        isNotValid = true;
                    }
                });
                if (isNotValid) {
                    // this.tabName = 'first';
                    this.$message({message: '请输入必填项', type: 'warning'});
                    return isNotValid;
                }
                for (let i = 0, len = this.forms.length; i < len; i++) {
                    this.$refs['customForm' + i][0].validate((valid) => {
                        if (!valid) {
                            isNotValid = true;
                        }
                    });
                }
                let newforms = this.$refs.approvalFormTab.getNewApprovalformField();
                // console.log(cloneDeep(newforms));
                let formRequireFieldList = {};
                for (let dIndex = 0; dIndex < this.formData.length; dIndex++) { // 校验表单特殊字段必填项
                    let fData = this.formData[dIndex];
                    if (ret && !ret[fData.formId]) { // 不需要校验
                        if (++dIndex >= this.formData.length) { // 最后一个循环
                            isNotValid = false;
                        }
                        continue;
                    }
                    for (var findex = 0; findex < newforms.length; findex++) {
                        let formInfo = newforms[findex];// 这里使用表单页签里的最新字段结构，用来处理级联显示字段的控制
                        // 流水号保存生成字段渲染
                        if (fData.formId === formInfo.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                            let requireArray = [];
                            for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                let field = formInfo.fieldsList[fieldIndex];
                                if (field.type === 'subform' && field.isView && (!field.formFieldAuth || field.formFieldAuth == '1') && isFormFieldVisible(field, fData.values)) {
                                    if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                        this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                        isNotValid = true;
                                        return isNotValid;
                                    } else { // 子表单有值，需要验证子表单内的必填项
                                        let subFlag = false;
                                        let sonFieldList = field.options.fieldList;
                                        let fieldNames = [];
                                        for (let i = 0; i < sonFieldList.length; i++) {
                                            let cur = sonFieldList[i];
                                            if (cur.options.required) { // 有必填项
                                                for (let i = 0; i < fData.values[field.formField].length; i++) {
                                                    let curObj = fData.values[field.formField][i];
                                                    if (!isFormFieldVisible(cur, curObj)) {
                                                        continue;
                                                    }
                                                    let curValue = curObj[cur.id];
                                                    if (!curValue) { // 有值
                                                        subFlag = true;
                                                        fieldNames.push(cur.label);
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                        if (subFlag) {
                                            isNotValid = true;
                                            this.$message({message: field.name + '中的' + fieldNames.join(',') + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                            return isNotValid;
                                        }
                                    }
                                } else if (isRequiredFormFieldVisible(field, fData.values) && (field.type === 'file' || field.type === 'category' || field.type === 'link' || field.type === 'select' || field.type === 'user') &&
                                (!field.formFieldAuth || field.formFieldAuth == '1')) {
                                    if (!fData.values[field.id] || fData.values[field.id] === '') {
                                        isNotValid = true;
                                        console.log(field);
                                        this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                        return isNotValid;
                                    }
                                } else if (field.type === 'archive' && field.isView && (!field.formFieldAuth || field.formFieldAuth == '1') && isFormFieldVisible(field, fData.values)) {
                                    if (field.options.required && field.options.config.type === 'multi' && !fData.values[field.formField + '-archiveId']) {
                                        isNotValid = true;
                                        this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                        return isNotValid;
                                    }
                                } else if (field.type === 'text' && field.isView && (!field.formFieldAuth || field.formFieldAuth == '1') && isFormFieldVisible(field, fData.values)) {
                                    if (field.options.ext1) { // 超链接字段
                                        if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                            this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                            return;
                                        }
                                    }
                                }
                                if (isRequiredFormFieldVisible(field, fData.values) && (!field.formFieldAuth || field.formFieldAuth == '1')) { // 当前字段是必填项
                                    requireArray.push(field.id);
                                }
                            }
                            let formId = formInfo.id;
                            if (formId) {
                                formRequireFieldList[formId] = requireArray;
                                fData['requireFieldArray'] = requireArray;
                            }
                        }
                    }
                }
                if (isNotValid) {
                    // this.tabName = 'second';
                    this.$message({message: '请输入必填项', type: 'warning'});
                    return isNotValid;
                }
                if (this.approvalInfo.approvalMethod == 3) { // 包含表单字段的审批
                    let approvePeopleList = this.approvalInfo.approvePeopleList;
                    if (approvePeopleList && approvePeopleList.length > 0) {
                        for (let i = 0; i < approvePeopleList.length; i++) {
                            let approvePeoples = approvePeopleList[i].approvePeoples;
                            for (let j = 0; j < approvePeoples.length; j++) {
                                let cur = approvePeoples[j];
                                if (cur.approvePeopleType == 'formField') {
                                    let formId = cur.formId;
                                    let fieldId = cur.id;
                                    for (let k = 0; k < this.formData.length; k++) {
                                        let form = this.formData[k];
                                        if (formId == form.formId) {
                                            let values = form.values;
                                            let userid = values[fieldId];
                                            let trueName = values[fieldId + '-user'];
                                            if (trueName != '' && userid != '') {
                                                approvePeoples[j].trueName = trueName;
                                                approvePeoples[j].userid = userid;
                                            } else {
                                                this.$message.error('表单关联审批人字段未填写');
                                                isNotValid = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (this.approvalForm.approvalName.length > 200) {
                    this.$message.error('审批名称过长,请控制在200字以内');
                    isNotValid = true;
                }
                this.approvalInfo.approvalName = this.approvalForm.approvalName;
                this.approvalInfo.approvalRemarks = this.approvalForm.approvalRemarks;
                this.approvalInfo.formJson = this.formData;

                // 关联子表必填校验TODO
                if (this.forms && this.forms.length > 0) {
                    // 关联子表必填校验
                    this.relateModelList = this.$refs.approvalFormTab.getRelateModelList();
                    // console.log(this.relateModelList);
                    // console.log(this.formData[0].values);
                    if (flag !== 0 && flag !== 1) {
                        if (this.forms[0].relateModelRequired && (this.relateModelList && this.relateModelList.length > 0)) {
                            let tempFormData = this.$refs.approvalFormTab.getTempFormData();
                            if (this.forms[0].id === '727d0cd345484dda86a130f566d61081') { // 中泽的合同信息表
                                // console.log(this.formData[0]);
                                // 获取合同类型的值
                                let itemValue = this.formData[0].values['8661037efcce49048b8e5d8c13356ef6'];
                                // 项目合同DEE500FA、业务结算合同97CDC0E0
                                if (itemValue === 'DEE500FA' || itemValue === '97CDC0E0') {
                                    if (tempFormData == null || tempFormData.length === 0) {
                                        this.$message({message: '关联子表是必填项，尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                        isNotValid = true;
                                    } else { // 多个关联子表，每个子表都需要校验是否有值了
                                        for (let k = 0; k < this.relateModelList.length; k++) {
                                            let relateModel = this.relateModelList[k];
                                            for (let j = 0; j < tempFormData.length; j++) {
                                                let relateFormData = tempFormData[j];
                                                if (relateFormData.formId === relateModel.formId) {
                                                    relateModel.hasData = true;
                                                    break;
                                                }
                                            }
                                            if (relateModel.hasData) {
                                                continue;
                                            } else {
                                                this.$message({message: '关联子表【' + relateModel.modelName + '】尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                                isNotValid = true;
                                            }
                                        }
                                    }
                                }
                            } else {
                                // if (this.approvalInfo.tempFormData) {
                                //     tempFormData = JSON.parse(this.approvalInfo.tempFormData);
                                // }
                                if (tempFormData == null || tempFormData.length === 0) {
                                    this.$message({message: '关联子表是必填项，尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                    isNotValid = true;
                                } else { // 多个关联子表，每个子表都需要校验是否有值了
                                    for (let k = 0; k < this.relateModelList.length; k++) {
                                        let relateModel = this.relateModelList[k];
                                        for (let j = 0; j < tempFormData.length; j++) {
                                            let relateFormData = tempFormData[j];
                                            if (relateFormData.formId === relateModel.formId) {
                                                relateModel.hasData = true;
                                                break;
                                            }
                                        }
                                        if (relateModel.hasData) {
                                            continue;
                                        } else {
                                            this.$message({message: '关联子表【' + relateModel.modelName + '】尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                            isNotValid = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                // 抄送人员
                // console.log("qqqqqqqq"+this.approvalInfo.selectedCopyUserIds);
                return isNotValid;
            },
            isToApproval () {
                if (this.approvalInfo.approvalMethod === 2) {
                    if (this.approvalInfo.approvalList.length > 0) {
                        let approUsers = [];
                        for (let index = 0, len = this.approvalInfo.approvalList.length; index < len; index++) {
                            if (this.approvalInfo.approvalList[index].length > 0) {
                                for (let j = 0; j < this.approvalInfo.approvalList[index].length; j++) {
                                    if (approUsers.indexOf(this.approvalInfo.approvalList[index][j].userId) > -1) {
                                        this.messageTip('不同节点中的审批人员有重复，请重新设置！', 'error');
                                        return false;
                                    } else {
                                        approUsers.push(this.approvalInfo.approvalList[index][j].userId);
                                    }
                                }
                                if (approUsers.length > 15) {
                                    this.messageTip('选择的审批人总数不能超过15人', 'warning');
                                    return false;
                                }
                            } else {
                                this.messageTip('审批流第' + (index + 1) + '节点无审批人，请添加至少1位审批人！', 'error');
                                return false;
                            }
                        }
                    } else {
                        this.$message({
                            message: '审批流不能为空',
                            type: 'warning',
                            duration: 3000
                        });
                        return false;
                    }
                } else {
                    if (isEmpty(this.approvalInfo.selectedUserIds)) {
                        this.$message({
                            message: '审批人不能为空，请先选择审批人',
                            type: 'warning',
                            duration: 3000
                        });
                        return false;
                    } else {
                        let approUsers = [];
                        let userIdsArray = this.approvalInfo.selectedUserIds.split(',');
                        for (let i = 0; i < userIdsArray.length; i++) {
                            if (approUsers.indexOf(userIdsArray[i]) > -1) {
                                this.messageTip('不同节点中的审批人员有重复，请重新设置！', 'error');
                                return false;
                            } else {
                                approUsers.push(userIdsArray[i]);
                            }
                        }
                    }
                }
                return true;
            },
            hasApplyUser () { // 提供给父组件使用
                // 共享流程可见标识
                this.isProcessShare = this.$refs.processFiles.getProcessShareValue();
                let b = false;
                if (this.approvalInfo.selectedUserIds !== undefined && this.approvalInfo.selectedUserIds !== '') {
                    if (this.approvalInfo.selectedUserIds.indexOf(this.userInfo.userId) !== -1) {
                        // this.$message({message: '申请人不能和审批人一致', type: 'warning'});
                        b = true;
                    }
                }
                return b;
            },
            hasRepeatUser () {
                let approvePeopleList = this.approvalInfo.approvePeopleList;
                if (this.approvalInfo.approvalMethod === 3 && approvePeopleList) { // 构造审批数据
                    for (let i = 0; i < approvePeopleList.length; i++) {
                        let curObj = approvePeopleList[i];
                        let approvePeoples = curObj.approvePeoples;
                        let allSelectedUserId = [];
                        approvePeoples.forEach(item => {
                            if (item.approvePeopleType === 'formField') {
                                allSelectedUserId.push(item.userid);
                            } else {
                                allSelectedUserId.push(item.selectedUserId);
                            }
                        });
                        for (let j = 0; j < approvePeoples.length; j++) {
                            let countFlag = 0;
                            let cur = approvePeoples[j];
                            allSelectedUserId.forEach(userId => {
                                let selectedUserId = '';
                                if (cur.approvePeopleType === 'formField') {
                                    selectedUserId = cur.userid;
                                } else {
                                    selectedUserId = cur.selectedUserId;
                                }
                                if (selectedUserId === userId) {
                                    countFlag = countFlag + 1;
                                }
                            });
                            if (countFlag > 1) { // 说明超过了一条,删除审批人
                                approvePeoples.splice(j, 1);
                            }
                        }
                        curObj.approvePeoples = cloneDeep(approvePeoples);
                    }
                    let approvalList = this.approvalInfo.approvalList;
                    for (let i = 0; i < approvalList.length; i++) {
                        let approvePeoples = approvalList[i];
                        let allSelectedUserId = [];
                        approvePeoples.forEach(item => {
                            allSelectedUserId.push(item.userId);
                        });
                        for (let j = 0; j < approvePeoples.length; j++) {
                            let countFlag = 0;
                            let cur = approvePeoples[j];
                            allSelectedUserId.forEach(userId => {
                                if (cur.userId === userId) {
                                    countFlag = countFlag + 1;
                                }
                            });
                            if (countFlag > 1) { // 说明超过了一条,删除审批人
                                approvePeoples.splice(j, 1);
                            }
                        }
                    }
                    let cacheApprovalInfoId = [];
                    let cacheapprovePeopleId = [];
                    for (let i = 0; i < this.approvalInfo.approvalList.length; i++) {
                        let approval = this.approvalInfo.approvalList[i];
                        let approvePeople = this.approvalInfo.approvePeopleList[i].approvePeoples;
                        for (let j = 0; j < approval.length; j++) {
                            let cur = approval[j];
                            if (cacheApprovalInfoId.indexOf(cur.userId) !== -1) { // 删除重复的数据
                                approval.splice(j, 1);
                                if (approval.length === 0) {
                                    this.approvalInfo.approvalList.splice(i, 1);
                                    this.approvalInfo.approvalUserGroupList.splice(i, 1);
                                    --i;
                                }
                            } else { // 加入缓存里
                                cacheApprovalInfoId.push(cur.userId);
                            }
                        }
                        for (let k = 0; k < approvePeople.length; k++) {
                            let cur = approvePeople[k];
                            if (cacheapprovePeopleId.indexOf(cur.userid) !== -1) { // 删除重复的数据
                                approvePeople.splice(k, 1);
                                if (approval.length === 0) {
                                    this.approvalInfo.approvePeopleList.splice(i, 1);
                                }
                            } else { // 加入缓存里
                                cacheapprovePeopleId.push(cur.userid);
                            }
                        }
                    }
                    // console.log("==============================");
                    // console.log(this.approvalInfo.approvalList);
                    // console.log(this.approvalInfo.approvePeopleList);
                }
            },
            convertCurrency (money) {
                // 汉字的数字
                var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
                // 基本单位
                var cnIntRadice = new Array('', '拾', '佰', '仟');
                // 对应整数部分扩展单位
                var cnIntUnits = new Array('', '万', '亿', '兆');
                // 对应小数部分单位
                var cnDecUnits = new Array('角', '分', '毫', '厘');
                // 整数金额时后面跟的字符
                var cnInteger = '整';
                // 整型完以后的单位
                var cnIntLast = '元';
                // 最大处理的数字
                var maxNum = 999999999999999.9999;
                // 金额整数部分
                var integerNum;
                // 金额小数部分
                var decimalNum;
                // 输出的中文金额字符串
                var chineseStr = '';
                // 分离金额后用的数组，预定义
                var parts;
                if (money == '') { return ''; }
                money = parseFloat(money);
                if (money >= maxNum) {
                // 超出最大处理数字
                    return '';
                }
                if (money == 0) {
                    chineseStr = cnNums[0] + cnIntLast + cnInteger;
                    return chineseStr;
                }
                // 转换为字符串
                money = money.toString();
                if (money.indexOf('.') == -1) {
                    integerNum = money;
                    decimalNum = '';
                } else {
                    parts = money.split('.');
                    integerNum = parts[0];
                    decimalNum = parts[1].substr(0, 4);
                }
                // 获取整型部分转换
                if (parseInt(integerNum, 10) > 0) {
                    var zeroCount = 0;
                    var IntLen = integerNum.length;
                    for (var i = 0; i < IntLen; i++) {
                        var n = integerNum.substr(i, 1);
                        var p = IntLen - i - 1;
                        var q = p / 4;
                        var m = p % 4;
                        if (n == '0') {
                            zeroCount++;
                        } else {
                            if (zeroCount > 0) {
                                chineseStr += cnNums[0];
                            }
                            // 归零
                            zeroCount = 0;
                            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                        }
                        if (m == 0 && zeroCount < 4) {
                            chineseStr += cnIntUnits[q];
                        }
                    }
                    chineseStr += cnIntLast;
                }
                // 小数部分
                if (decimalNum != '') {
                    var decLen = decimalNum.length;
                    for (var i = 0; i < decLen; i++) {
                        var n = decimalNum.substr(i, 1);
                        if (n != '0') {
                            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                        }
                    }
                }
                if (chineseStr == '') {
                    chineseStr += cnNums[0] + cnIntLast + cnInteger;
                } else if (decimalNum == '') {
                    chineseStr += cnInteger;
                }
                return chineseStr;
            },
            async handelSaveForms (opType) {
                if (isEmpty(this.approvalForm.approvalName) || this.approvalTemplateObj.nameReadOnly) { // 设置了命名规则，也没有手动填写或修改名称，则需要重新获取下名称
                    await this.getDefaultApproveName(); // 获取默认审批流模板名称
                }
                this.approvalInfo.approvalName = this.approvalForm.approvalName;
                this.approvalInfo.approvalRemarks = this.approvalForm.approvalRemarks;
                this.approvalInfo.orderMode = this.approvalForm.orderMode;
                this.approvalInfo.rejectMode = this.approvalForm.rejectMode;
                this.approvalInfo.sendSms = this.approvalForm.sendSms;
                this.approvalInfo.durTime = this.approvalForm.durTime;
                this.approvalInfo.warnDate = this.approvalForm.warnDate;
                this.approvalInfo.remarks = this.approvalForm.remarks;
                this.approvalInfo.isProcessShare = this.isProcessShare;
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let isNotValid = this.checkFormValid();
                if (!isNotValid) {
                    for (let i = 0; i < this.forms.length; i++) {
                        let values = this.formData[i].values;
                        let formId = this.formData[i].formId;
                        let modelId = this.forms[i].modelId;
                        let fieldsList = this.forms[i].fieldsList;
                        fieldsList.forEach(field => {
                            if (field.type === 'text') {
                                if (field.options.upMoneyField) { // 配置了金额大写
                                    let upMoneyId = field.options.upMoneyField;
                                    let res = this.convertCurrency(values[upMoneyId]);
                                    values[field.id] = res;
                                }
                            }
                        });
                        let param = {values: values, formId: formId, modelId: modelId, modelType: 0};
                        let res = await checkDataLegitimacy(param);
                        if (res.state !== 'success') {
                            if (res.msg) {
                                this.$message.error(res.msg);
                            } else {
                                this.$message.error('数据不合法');
                            }
                            loading.close();
                            return true;
                        }
                    }
                    this.approvalInfo.opType = opType; // opType 操作模式：1 保存草稿 2发起审批
                    // this.approvalInfo.orderMode = 0;// 是否顺序审批 0否 1是
                    if (!this.isInstance) {
                        this.approvalInfo.templateId = this.approvalTemplateObj.id;// 审批流模板
                    } else {
                        this.approvalInfo.id = this.approvalTemplateObj.id;// 审批流id
                        this.approvalInfo.templateId = this.approvalTemplateObj.templateId;// 审批流模板
                    }
                    this.approvalInfo.processInstanceId = this.instances.id;
                    this.approvalInfo.processServiceId = this.approvalTemplateObj.processServiceId;
                    this.approvalInfo.deploymentId = this.approvalTemplateObj.deploymentId;
                    if (opType === 2) { // 发起审批时，表单为新增表单时，“保存时自动生成”的流水号在此生成
                        await this.renderSerialNumber();
                    }
                    isNotValid = await this.checkNumberRule();
                    if (isNotValid) { // 校验数字类型字段
                        loading.close();
                        return isNotValid;
                    }
                    this.approvalInfo.formJson = this.formData;
                    if (!isEmpty(this.approvalTemplateObj.parentApprovalId)) {
                        this.approvalInfo.parentApprovalId = this.approvalTemplateObj.parentApprovalId;
                    }
                    if (!isEmpty(this.approvalTemplateObj.mainApprovalId)) {
                        this.approvalInfo.mainApprovalId = this.approvalTemplateObj.mainApprovalId;
                    }
                    if (!isEmpty(this.busiProcessInstanceId)) { // 传送业务流程ID
                        this.approvalInfo.busiProcessInstanceId = this.busiProcessInstanceId;
                    }
                    if (!isEmpty(this.busiTaskInstanceId)) { // 传送业务流程任务ID
                        this.approvalInfo.busiTaskInstanceId = this.busiTaskInstanceId;
                    }
                    if (!isEmpty(this.busiTaskInstanceId) && this.taskParam) {
                        this.approvalInfo.isFromProcessTaskForms = '1';
                        this.approvalInfo.taskNode = this.taskParam;
                        // 替换任务表单数据,用于同步任务表单和审批流表单数据begin
                        let newTaskForms = [];
                        if (this.taskParam && this.taskParam.forms && this.taskParam.forms.length > 0) {
                            // 将任务的表单同步成审批流里的表单数据
                            if (this.approvalInfo.formJson && this.approvalInfo.formJson.length > 0) {
                                for (let i = 0; i < this.taskParam.forms.length; i++) {
                                    let taskform = this.taskParam.forms[i];
                                    for (let j = 0; j < this.approvalInfo.formJson.length; j++) {
                                        let approvalForm = this.approvalInfo.formJson[j];
                                        if (taskform.formId === approvalForm.formId) {
                                            taskform = clone(approvalForm);
                                        }
                                    }
                                    newTaskForms.push(taskform);
                                }
                            }
                        }
                        this.taskParam.forms = newTaskForms;
                        // 替换任务表单数据,用于同步任务表单和审批流表单数据end
                    }
                    // 审批来源
                    this.approvalInfo.belong = this.belongProcessFlag;
                    try {
                        // 发起审批时的默认抄送人
                        this.approvalInfo.copyUserIds = this.approvalInfo.selectedCopyUserIds;
                        this.approvalInfo.copyUserNames = this.approvalInfo.selectedCopyUserNames;
                        if (this.taskParam) {
                            this.approvalInfo.updHisProcessDataFlag = this.taskParam.updHisProcessDataFlag;
                        }
                        if (this.formDataFromBusiness) {
                            this.approvalInfo.formDataIds = this.formDataFromBusiness.dataId; // 从业务应用表单发起的审批流
                            if (this.formDataFromBusiness.values) {
                                this.approvalInfo.taskformDataId = this.formDataFromBusiness.values.id; // 从任务表单发起的审批流
                            } else {
                                this.approvalInfo.taskformDataId = '';
                            }
                        } else {
                            this.approvalInfo.formDataIds = '';
                            this.approvalInfo.taskformDataId = '';
                        }
                        // 关联的表单数据 多表单情况暂时只支持第一个表单有主子表单结构
                        let mainModelInfo = {modelId: this.forms[0].modelId, tempFormData: this.$refs.approvalFormTab.getTempFormData()};
                        this.approvalInfo.mainModelInfo = mainModelInfo;

                        // ===============按部门指定审批人begin================================
                        if (this.approvalInfo.approvalMethod === 3) {
                            // 根据部门指定的审批人，重置当前审批流的审批人begin
                            // 是配置了按部门选人模式的话，根据填写的部门信息获取配置的审批人
                            let depUserLinkUserArr = [];
                            let deptUserlinkData = this.approvalTemplateObj.deptUserlinkData;
                            let onlyUserNode = false;
                            if (deptUserlinkData && deptUserlinkData.length > 0) {
                                for (let i = 0; i < deptUserlinkData.length; i++) {
                                    let deptUserlinkDataItem = deptUserlinkData[i];
                                    for (let k = 0; k < this.formData.length; k++) {
                                        let form = this.formData[k];
                                        if (deptUserlinkDataItem.formId === form.formId) {
                                            let values = form.values;
                                            let deptId = values[deptUserlinkDataItem.formFieldId];
                                            let matchFlg = false;
                                            // edit by hezhen 进行部门多选时的逻辑重构
                                            if (deptUserlinkDataItem.formFieldValue && deptUserlinkDataItem.formFieldValue.indexOf(',') !== -1) {
                                                matchFlg = deptId && deptUserlinkDataItem.formFieldValue.indexOf(deptId) !== -1;
                                            } else {
                                                matchFlg = deptId && deptId == deptUserlinkDataItem.formFieldValue;
                                            }
                                            // if (deptId && deptId == deptUserlinkDataItem.formFieldValue) {
                                            if (matchFlg) {
                                                if (deptUserlinkDataItem.selectedUserIds) {
                                                    let userIdArr = deptUserlinkDataItem.selectedUserIds.split(',');
                                                    let trueNameArr = deptUserlinkDataItem.selectedUserNames.split(',');
                                                    onlyUserNode = deptUserlinkDataItem.onlyUserNode;
                                                    for (let j = 0; j < userIdArr.length; j++) {
                                                        let userBo = {userId: '', trueName: ''};
                                                        userBo.userId = userIdArr[j];
                                                        userBo.trueName = trueNameArr[j];
                                                        depUserLinkUserArr.push(userBo);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            // 根据部门指定的审批人，重置当前审批流的审批人end

                            if (depUserLinkUserArr.length > 0) {
                                if (onlyUserNode) {
                                    this.approvalInfo.approvePeopleList = JSON.parse(JSON.stringify(this.defaultApprovePeopleList));
                                    let approvePeopleList = this.approvalInfo.approvePeopleList;
                                    if (approvePeopleList && approvePeopleList.length > 0) {
                                        for (let i = 0; i < approvePeopleList.length; i++) {
                                            let approvePeoples = approvePeopleList[i].approvePeoples;
                                            // 根据部门指定的审批人，重置当前审批流的审批人begin
                                            if (depUserLinkUserArr.length > 0 && onlyUserNode) {
                                                let isUsed = false;
                                                let curUserBo = depUserLinkUserArr[0]; // 获取部门人员配置的人员信息.每次从第一条获取，用完后移除
                                                if (approvePeoples[0].approvePeopleType === 'user') {
                                                    approvePeoples[0].selectedUserId = curUserBo.userId;
                                                    approvePeoples[0].selectedUserName = curUserBo.trueName;
                                                    isUsed = true;
                                                }
                                                if (isUsed) {
                                                    depUserLinkUserArr.shift();
                                                }
                                            }
                                            // 根据部门指定的审批人，重置当前审批流的审批人end
                                        }
                                    }
                                } else {
                                    // 部门指定负责人，覆盖默认的负责人信息
                                    this.approvalInfo.approvePeopleList = [];
                                    for (let k = 0; k < depUserLinkUserArr.length; k++) {
                                        let curUserBo = depUserLinkUserArr[k];
                                        let approvalNode = {
                                            id: '',
                                            approveOrder: k,
                                            approveWay: 1,
                                            approvePeoples: []
                                        };
                                        let approvalUser = {};
                                        approvalUser.selectedUserId = curUserBo.userId;
                                        approvalUser.selectedUserName = curUserBo.trueName;
                                        approvalUser.approvePeopleType = 'user';
                                        approvalNode.approvePeoples.push(approvalUser);
                                        this.approvalInfo.approvePeopleList.push(approvalNode);
                                    }
                                }
                            }
                        } else if (this.approvalInfo.approvalMethod === 1) {
                            let deptUserlinkData = this.approvalTemplateObj.deptUserlinkData;
                            if (deptUserlinkData && deptUserlinkData.length > 0) {
                                for (let i = 0; i < deptUserlinkData.length; i++) {
                                    let deptUserlinkDataItem = deptUserlinkData[i];
                                    for (let k = 0; k < this.formData.length; k++) {
                                        let form = this.formData[k];
                                        if (deptUserlinkDataItem.formId === form.formId) {
                                            let values = form.values;
                                            let deptId = values[deptUserlinkDataItem.formFieldId];
                                            // if (deptId && deptId == deptUserlinkDataItem.formFieldValue) {
                                            let matchFlg = false;
                                            // edit by hezhen 进行部门多选时的逻辑重构
                                            if (deptUserlinkDataItem.formFieldValue && deptUserlinkDataItem.formFieldValue.indexOf(',') !== -1) {
                                                matchFlg = deptId && deptUserlinkDataItem.formFieldValue.indexOf(deptId) !== -1;
                                            } else {
                                                matchFlg = deptId && deptId == deptUserlinkDataItem.formFieldValue;
                                            }
                                            // if (deptId && deptId == deptUserlinkDataItem.formFieldValue) {
                                            if (matchFlg) {
                                                this.approvalInfo.selectedUserIds = deptUserlinkDataItem.selectedUserIds;
                                                this.approvalInfo.selectedUserNames = deptUserlinkDataItem.selectedUserNames;
                                                this.approvalForm.selectedUser.selectedUserIds = this.approvalInfo.selectedUserIds;
                                                this.approvalForm.selectedUser.selectedUserNames = this.approvalInfo.selectedUserNames;
                                                this.selectUsers = [];
                                                this.selectUsers = this.approvalInfo.selectedUserNames.split(',');
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        // ===============按部门指定审批人end================================
                        let approvePeopleList = this.approvalInfo.approvePeopleList;
                        if (this.approvalInfo.approvalMethod == 3 && approvePeopleList) { // 构造审批数据
                            let userids = [];
                            let userName = [];
                            let approvalList = [];
                            let executionOrder = 0;
                            let approvalUserGroupList = [];
                            for (let i = 0; i < approvePeopleList.length; i++) {
                                let cur = approvePeopleList[i];
                                let approvePeoples = cur.approvePeoples;
                                let approvalItem = [];
                                let approvalUserGroupListItem = {};
                                approvalUserGroupListItem.id = cur.id;
                                approvalUserGroupListItem.templateId = this.approvalInfo.templateId;
                                approvalUserGroupListItem.executionGroupOrder = cur.approveOrder;
                                approvalUserGroupListItem.approvalMultiSignType = cur.approveWay;
                                approvalUserGroupList.push(approvalUserGroupListItem);
                                for (let j = 0; j < approvePeoples.length; j++) {
                                    let user = approvePeoples[j];
                                    let userItem = {};
                                    if (user.approvePeopleType === 'user') {
                                        userids.push(user.selectedUserId);
                                        userName.push(user.selectedUserName);
                                        userItem.userId = user.selectedUserId;
                                        userItem.trueName = user.selectedUserName;
                                    } else if (user.approvePeopleType === 'formField') {
                                        userids.push(user.userid);
                                        userName.push(user.trueName);
                                        userItem.userId = user.userid;
                                        userItem.trueName = user.trueName;
                                    }
                                    userItem.executionOrder = executionOrder;
                                    executionOrder = executionOrder + 1;
                                    userItem.executionGroupOrder = i;
                                    approvalItem.push(userItem);
                                }
                                approvalList.push(approvalItem);
                            }
                            let selectedUserIds = userids.join(',');
                            let selectedUserNames = userName.join(',');
                            this.approvalInfo.selectedUserIds = selectedUserIds;
                            this.approvalInfo.selectedUserNames = selectedUserNames;
                            this.approvalInfo.approvalList = approvalList;
                            this.approvalInfo.approvalUserGroupList = approvalUserGroupList;
                            this.hasRepeatUser();
                        }
                        // 构造抄送人员
                        if (this.copyUserObj && this.copyUserObj.length > 0) { // 说明有抄送人
                            this.copyUserObj.forEach(item => {
                                if (item.approvePeopleType === 'formField') { // 字段类型
                                    for (let i = 0; i < this.formData.length; i++) {
                                        let cur = this.formData[i];
                                        let values = cur.values;
                                        item.trueName = values[item.id + '-user'];
                                        item.userId = values[item.id];
                                    }
                                }
                            });
                        }
                        if (this.approvalTemplateObj.deleteOldData || this.approvalInfo.isDeleteOldData || this.approvalTemplateObj.isDeleteOldData) {
                            this.approvalInfo.isDeleteOldData = true;
                        } else {
                            this.approvalInfo.isDeleteOldData = false;
                        }
                        let copyUserIdsArray = [];
                        let copyUserNamesArray = [];
                        this.copyUserObj.forEach(item => {
                            copyUserIdsArray.push(item.userId);
                            copyUserNamesArray.push(item.trueName);
                        });
                        this.copyUserObjTwo.forEach(item => {
                            copyUserIdsArray.push(item.userId);
                            copyUserNamesArray.push(item.trueName);
                        });
                        this.approvalInfo.copyUserIds = copyUserIdsArray.join(',');
                        this.approvalInfo.copyUserNames = copyUserNamesArray.join(',');
                        this.approvalInfo.oldProcessInstanceId = this.approvalTemplateObj.oldProcessInstanceId;
                        this.approvalInfo.abstractField = this.approvalTemplateObj.abstractField;
                        this.approvalInfo.approvalAbstract = this.approvalTemplateObj.approvalAbstract;
                        await saveApprovalInstance(this.approvalInfo);
                        loading.close();
                        return isNotValid;
                    } catch (error) {
                        loading.close();
                        this.$message({message: error.msg, type: 'warning', duration: 3000});
                        // console.error(error);
                    }
                } else {
                    loading.close();
                    return isNotValid;
                }
            },
            async renderSerialNumber () {
                if (this.forms && this.formData && this.forms.length > 0 && this.formData.length > 0) {
                    for (var dIndex = 0; dIndex < this.formData.length; dIndex++) {
                        if (this.formData[dIndex].values.id) {
                            continue;
                        }
                        let fData = this.formData[dIndex];
                        for (var findex = 0; findex < this.forms.length; findex++) {
                            let formInfo = this.forms[findex];
                            // 流水号保存生成字段渲染
                            if (fData.formId === formInfo.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                                for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                    let field = formInfo.fieldsList[fieldIndex];
                                    // 假如是流水号字段并且流水号有值的情况下就不走流水号生成逻辑了
                                    if (field.type === 'serialNumber' && !isEmpty(fData.values[field.id])) {
                                        console.log(field.name + '---------' + field.type);
                                        console.log(fData.values[field.id]);
                                        continue;
                                    }
                                    if (field.type === 'subform' && fData.values[field.id] && fData.values[field.id].length > 0) {
                                        for (var dataIndex = 0; dataIndex < fData.values[field.id].length; dataIndex++) {
                                            var subData = fData.values[field.id][dataIndex];
                                            for (var subFieldIndex = 0; subFieldIndex < field.options.fieldList.length; subFieldIndex++) {
                                                let subField = field.options.fieldList[subFieldIndex];
                                                if (subField.type === 'serialNumber' && subField.options.ext3 === '2' && subField.options.config.options.length > 0 && !subData[subField.id]) {
                                                    await this.setSerialNumber(subField.options.config.options[0].value, subField, subData, formInfo);
                                                }
                                            }
                                        }
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '2' && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                        await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                        let ext2Obj = JSON.parse(field.options.ext2);
                                        let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                        if (ext2Obj.seriaNumberGenerateFieldIdValue && typeof (ext2Obj.seriaNumberGenerateFieldIdValue) === 'object') {
                                            for (let i = 0; i < ext2Obj.seriaNumberGenerateFieldIdValue.length; i++) {
                                                if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue[i]) {
                                                    await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                                }
                                            }
                                        } else {
                                            if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                                await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                            }
                                        }
                                    } else if (field.type === 'serialNumber') { // 多规则的流水号生成规则
                                        let ext2 = field.options.ext2;
                                        if (ext2) {
                                            let ext2Obj = JSON.parse(ext2);
                                            if (ext2Obj.moreSerialNumber) { // 多规则配置
                                                let seriaNumberAutoincrementType = null;
                                                let serialNumberRuleList = ext2Obj.serialNumberRuleList;
                                                for (let i = 0; i < serialNumberRuleList.length; i++) {
                                                    let element = serialNumberRuleList[i];
                                                    let takeEffectField = element.takeEffectField;
                                                    let takeEffectFieldValue = element.takeEffectFieldValue;
                                                    let formFieldVal = fData.values[takeEffectField];
                                                    if (element.seriaNumberAutoincrementType) { // 说明配置了自增体 1部门自增体 流水号自增体
                                                        seriaNumberAutoincrementType = element.seriaNumberAutoincrementType;
                                                    }
                                                    if (takeEffectFieldValue.indexOf(formFieldVal) !== -1) { // 满足条件了
                                                        if (element.seriaNumberDepartTypeFormFieldId) {
                                                            ext2Obj.seriaNumberDepartTypeFormFieldId = element.seriaNumberDepartTypeFormFieldId;
                                                        }
                                                        if (element.seriaNumberDepartTypeFormFieldIdValue) {
                                                            ext2Obj.seriaNumberDepartTypeFormFieldIdValue = element.seriaNumberDepartTypeFormFieldIdValue;
                                                        }
                                                        if (element.seriaNumberSelectTypeFormFieldId) {
                                                            ext2Obj.seriaNumberSelectTypeFormFieldId = element.seriaNumberSelectTypeFormFieldId;
                                                        }
                                                        field.options.ext2 = JSON.stringify(ext2Obj);
                                                        await this.setSerialNumber(element.selectedNode.id, field, fData.values, formInfo, seriaNumberAutoincrementType);
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            async setSerialNumber (sid, field, formData, formInfo, seriaNumberAutoincrementType) {
                if (sid) {
                    let busiId = null;
                    let departId = null;
                    let configOptionId = null;
                    let upSerialNumber = null; // 国融合同表单框架合同号
                    for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                        let tempField = formInfo.fieldsList[fieldIndex];
                        if (tempField.type === 'businessTree') {
                            busiId = formData[tempField.formField];
                        } else if (tempField.type === 'department') {
                            departId = formData[tempField.formField];
                        } else if (tempField.type === 'select') {
                            // 中泽的项目立项表的业务分类选项字段
                            if (tempField.id === '1d3bb7fd093943709bfbd36fd6c15ca4') {
                                let optionValue = formData[tempField.formField];
                                let configOptions = tempField.options.config.options;
                                for (let k = 0; k < configOptions.length; k++) {
                                    let item = configOptions[k];
                                    if (item.value === optionValue) {
                                        configOptionId = item.id;
                                        break;
                                    }
                                }
                            }
                        } else if (tempField.type === 'link') {
                            if (formInfo.id === 'b81cbd9fa972415ebb00d3e40e1f5522') { // 国融【合同信息表】
                                if (tempField.id === '7abddcef62424e4b99145cfa7080e42c') { // 合同表单的【关联框架合同】字段
                                    let linkObj = formData[tempField.formField];
                                    // console.log(linkObj);
                                    if (linkObj) {
                                        let linkObjTableData = linkObj['tableData'][0];
                                        if (linkObjTableData) {
                                            // 合同编号 c6219b4ce1e94150b0f0a00ab63ecf83
                                            upSerialNumber = linkObjTableData['c6219b4ce1e94150b0f0a00ab63ecf83'];
                                            // console.log(upSerialNumber);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    let numberObj = null;
                    let departmentId = null;
                    if (field.options.ext2) {
                        let ext2Obj = JSON.parse(field.options.ext2);
                        if (ext2Obj.seriaNumberFormFieldId) { // 部门占位符取值
                            departmentId = formData[ext2Obj.seriaNumberFormFieldId];
                            if (departmentId) {
                                departmentId = Number(departmentId);
                                let param = {id: sid, busiId: busiId, departId: departId, departmentId: departmentId};
                                if (seriaNumberAutoincrementType) {
                                    param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                }
                                numberObj = await getSerialNumberDepartment(param);
                            } else {
                                this.$message.error('流水号关联的部门未选取,数据无法生成流水号');
                                return;
                            }
                        } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId && ext2Obj.seriaNumberDepartTypeFormFieldId) { // 业务分类和部门都选择的
                            let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                            let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                            let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    // if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    // }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId) { // 业务分类
                            let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                            let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    // if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    // }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else if (ext2Obj.seriaNumberDepartTypeFormFieldId) { // 部门
                            let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                            let param = {id: sid, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    // if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    // }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                            let param = {id: sid};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    //   if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    //   }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else {
                            if (busiId && departId) {
                                numberObj = await getSerialNumber(sid, busiId, departId);
                            } else if (departId && configOptionId) { // 根据部门和选项值获取流水号
                                numberObj = await getSerialNumberDepAndOption(sid, departId, configOptionId);
                            } else {
                                numberObj = await getSerialNumber(sid);
                            }
                        }
                    } else {
                        if (busiId && departId) {
                            numberObj = await getSerialNumber(sid, busiId, departId);
                        } else if (departId && configOptionId) { // 根据部门和选项值获取流水号
                            numberObj = await getSerialNumberDepAndOption(sid, departId, configOptionId);
                        } else {
                            numberObj = await getSerialNumber(sid);
                        }
                    }
                    if (numberObj) {
                        formData[field.formField] = numberObj.newSerialNumber;
                        formData[field.formField + '-sn'] = numberObj.sn;
                        if (upSerialNumber) {
                            formData[field.formField] = upSerialNumber + '-' + numberObj.newSerialNumber;
                        }
                        // console.log(formData[field.formField]);
                    }
                    // 更新流水号记录为已使用状态
                    let param = {id: numberObj.sn, serialNumber: numberObj.newSerialNumber};
                    let res = upDateSerialNumberState(param);
                    if (res.state && res.state === 'error') {
                        this.$message.error('流水号生成失败');
                    }
                }
            },
            async checkNumberRule () {
                let isRefuse = false;
                if (this.forms && this.formData && this.forms.length > 0 && this.formData.length > 0) {
                    for (var dIndex = 0; dIndex < this.formData.length; dIndex++) {
                        // if (this.formData[dIndex].values.id) {
                        //     continue;
                        // }
                        let fData = this.formData[dIndex];
                        for (var findex = 0; findex < this.forms.length; findex++) {
                            let formInfo = this.forms[findex];
                            // 检查数字类型校验
                            let resObj = await this.$refs.fieldValidation.validateNumberRule(formInfo.fieldsList, fData.values);
                            if (resObj.isRefuse) {
                                let tempRefName = resObj.tempRefName;
                                let tempRefKey = resObj.tempRefKey;
                                if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                    this.$refs[tempRefName][0].fieldFocus(tempRefKey);
                                }
                                this.$message({message: '表单字段校验失败!' + resObj.refuseInfo, type: 'warning', duration: 3000});
                                isRefuse = true;
                                break;
                            }
                        }
                    }
                }
                return isRefuse;
            },
            confirmClick (approvalMultiSignType) {
                this.$refs.userOrgExt.setChoosedUser();
                this.selectUsers = [];
                this.selectUsers = this.selectedUser.selectedUserNames.split(',');
                if (this.selectUsers.length > 15) {
                    this.$message({
                        message: '选择的审批人总数不能超过15人',
                        type: 'warning',
                        duration: 3000
                    });
                    this.selectUsers = [];
                    this.selectedUser.selectedUserIds = '';
                    this.selectedUser.selectedUserNames = '';
                    return false;
                }
                this.totalNum = this.selectUsers.length;
                this.approvalForm.selectedUser = this.selectedUser;
                this.approvalInfo.selectedUserIds = this.selectedUser.selectedUserIds;
                this.approvalInfo.selectedUserNames = this.selectedUser.selectedUserNames;
                this.isShowUserOrg = false;
                this.approvalUserActiveName = 'approvalUserItem';
                if (this.approvalInfo.approvalMethod === 2) {
                    let selectedUserIds = this.selectedUser.selectedUserIds.split(',');
                    this.approvalInfo.approvalList[this.currentIndex] = [];
                    if (this.selectedUser.selectedUserIds) {
                        for (let index = 0, len = selectedUserIds.length; index < len; index++) {
                            this.approvalInfo.approvalList[this.currentIndex].push({
                                executionGroupOrder: this.currentIndex,
                                userId: selectedUserIds[index],
                                trueName: this.selectUsers[index]
                            });
                        }
                        this.approvalInfo.approvalUserGroupList[this.currentIndex].approvalMultiSignType = approvalMultiSignType;
                        this.loadTimer = new Date().getTime();
                    }
                }
            },
            chooseUser () {
                setTimeout(() => { // 初始化
                    this.$refs.userOrgExt._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            confirmCopyUserClick () {
                this.$refs.userOrgExtCopy.setChoosedUser();
                this.selectCopyUsers = [];
                this.selectCopyUsers = this.selectedCopyUser.selectedUserNames.split(',');
                if (this.selectCopyUsers.length > 15) {
                    this.$message({
                        message: '选择的抄送人员总数不能超过15人',
                        type: 'warning',
                        duration: 3000
                    });
                    this.selectCopyUsers = [];
                    this.selectedCopyUser.selectedCopyUserIds = '';
                    this.selectedCopyUser.selectedCopyUserNames = '';
                    return false;
                }
                this.approvalInfo.selectedCopyUserIds = this.selectedCopyUser.selectedUserIds;
                this.approvalInfo.selectedCopyUserNames = this.selectedCopyUser.selectedUserNames;
                this.isShowCopyUserOrg = false;
            },
            chooseCopyUser () {
                setTimeout(() => { // 初始化
                    this.$refs.userOrgExtCopy._initPage();
                }, 0);
                this.isShowCopyUserOrg = true;
            },
            chooseProcess () {
                if (this.btnMode === 0 || this.btnMode === 3) {
                    this.isShowProcessListDialog = true;
                }
            },
            async handleClickOk () {
                // if (isEmpty(this.approvalInfo.busiProcessInstanceId)) {
                //     this.$message({ message: '请选择所属流程', type: 'warning', uration: 3000 });
                //     return false;
                // }
                this.isShowProcessListDialog = false;
            },
            selectTrigger (selected) { // 选择流程
                this.approvalInfo.busiProcessInstanceId = selected.id;
                this.approvalInfo.busiProcessInstanceName = selected.label;
            },
            handleChangeCollapse0 (val) {
                if (val) {
                    this.approvalBaseActiveName = 'approvalBaseItem';
                    this.collapseActiveName = '';
                } else {
                    this.collapseActiveName = this.forms[0].id;
                }
            },
            handleChangeCollapse3 (val) {
                if (val) {
                    this.approvalBaseActiveName = '';
                    this.approvalUserActiveName = '';
                    this.approvalSettingActiveName = '';
                    this.approvalRecordActiveName = '';
                } else {
                    this.approvalBaseActiveName = 'approvalBaseItem';
                    this.approvalRecordActiveName = 'approvalRecordItem';
                }
            },
            handleChangeCollapse4 () {
                this.approvalRecordActiveName = 'approvalRecordItem';
                this.collapseActiveName = '';
                this.approvalUserActiveName = '';
                this.approvalSettingActiveName = '';
            },
            handleDeleteUser (index) {
                this.countersignUsers.splice(index, 1);
            },
            addApproval () {
                if (this.approvalInfo.approvalList.length < 15) {
                    this.approvalInfo.approvalList.push([]);
                    this.approvalInfo.approvalUserGroupList.push({
                        executionGroupOrder: (this.approvalInfo.approvalList.length - 1),
                        approvalMultiSignType: 1
                    });
                    this.loadTimer = new Date().getTime();
                }
            },
            chooseApproveUser (index) {
                if (this.approvalForm.approvalUserReadOnly) {
                    return false;
                }
                this.currentIndex = index;
                this.selectUsers = [];
                this.selectedUser.selectedUserIds = '';
                this.selectedUser.selectedUserNames = '';
                let currentNode = this.approvalInfo.approvalList[index];
                for (let i = 0, len = currentNode.length; i < len; i++) {
                    if (i === 0) {
                        this.selectedUser.selectedUserIds = currentNode[i].userId;
                        this.selectedUser.selectedUserNames = currentNode[i].trueName;
                    } else {
                        this.selectedUser.selectedUserIds = this.selectedUser.selectedUserIds + ',' + currentNode[i].userId;
                        this.selectedUser.selectedUserNames = this.selectedUser.selectedUserNames + ',' + currentNode[i].trueName;
                    }
                }
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.userOrgExt._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            addApprovePeopleList (obj) {
                this.approvePeopleItemArray = [];
                this.approvePeopleItemArray.push(obj);
                this.isShowApproveSetNode = true;
            },
            saveApproveRule (obj) {
                for (let i = 0; i < this.approvalInfo.approvePeopleList.length; i++) {
                    let cur = this.approvalInfo.approvePeopleList[i];
                    if (cur.id == obj.id) {
                        this.approvalInfo.approvePeopleList[i] = obj;
                    }
                }
                this.isShowApproveSetNode = false;
            },
            handleDeleteNode () {
                this.approvalInfo.approvalList.splice(this.currentIndex, 1);
                this.approvalInfo.approvalUserGroupList.splice(this.currentIndex, 1);
                this.isShowUserOrg = false;
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            loadLinkData (data, targetField) {
                for (let index = 0, len = this.forms.length; index < len; index++) {
                    if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                        for (var i = 0; i < this.forms[index].fieldsList.length; i++) {
                            let tempField = this.forms[index].fieldsList[i];
                            if (targetField.id === tempField.id) {
                                this.$refs['fieldItemChild' + i][0].initAddLinkData(data);
                            }
                        }
                    }
                }
            },
            async refreshViewField (relateModelMap) {
                // this.loadTimerField = new Date().getTime();
                if (relateModelMap && relateModelMap.size > 0) { // 级联显示子表单控制
                    this.relateModelMap = new Map();
                    this.relateModelMap = relateModelMap;
                    if (this.relateModelList) {
                        for (let i = 0; i < this.relateModelList.length; i++) {
                            let model = this.relateModelList[i];
                            if (relateModelMap.has(model.id)) {
                                model.hiddenElement = !relateModelMap.get(model.id);
                                //   this.showRelateFormTab = relateModelMap.get(model.id);
                                if (relateModelMap.get(model.id)) {
                                    this.showRelateFormTab = true;
                                    //   await this.renderModelFormList(model);
                                }
                                //   if (this.showRelateFormTab) {
                                //       await this.renderModelFormList(model);
                                //   }
                            }
                        }
                        for (let i = 0; i < this.relateModelList.length; i++) {
                            let cur = this.relateModelList[i];
                            if (!cur.hiddenElement) {
                                this.relateFormTabName = cur.id;
                                await this.renderModelFormList(cur);
                                break;
                            }
                        }
                    }
                } else {
                    this.loadTimerField = new Date().getTime();
                }
            },
            handleShowHisApprovalDialog () {
                this.loadTimer = new Date().getTime();
                this.isShowHisApprovalDialog = true;
            },
            hisApprovalSelectCancel () {
                this.isShowHisApprovalDialog = false;
            },
            hisApprovalSelectConfirm (selectedApprovalInstance) {
                this.selectedUser.selectedUserIds = selectedApprovalInstance.selectedUserIds;
                this.selectedUser.selectedUserNames = selectedApprovalInstance.selectedUserNames;
                this.selectUsers = [];
                this.selectUsers = this.selectedUser.selectedUserNames.split(',');
                this.totalNum = this.selectUsers.length;
                this.approvalForm.selectedUser = this.selectedUser;
                this.approvalInfo.selectedUserIds = this.selectedUser.selectedUserIds;
                this.approvalInfo.selectedUserNames = this.selectedUser.selectedUserNames;
                if (this.approvalInfo.approvalMethod === 2) {
                    this.approvalInfo.approvalList = selectedApprovalInstance.approvalList;
                    this.approvalInfo.approvalUserGroupList = selectedApprovalInstance.approvalUserGroupList;
                    this.loadTimer = new Date().getTime();
                }
                this.isShowHisApprovalDialog = false;
            },
            getSubformName (formData, field) {
                if (Array.isArray(formData[field.id])) {
                    return field.name + '(' + formData[field.id].length + ')';
                } else {
                    return field.name + '(0)';
                }
            },
            async asynMainFormData (sourceData, selectTableColumns, currentlinkFieldId, index) {
                if (selectTableColumns && Array.isArray(selectTableColumns)) {
                    let targetFormFieldlist = this.forms[index].fieldsList;
                    selectTableColumns.forEach(fieldObj => {
                        let sourceFieldLabel = fieldObj.label;
                        targetFormFieldlist.forEach(element => {
                            if (element.options.synLinkField && element.options.synLinkField === currentlinkFieldId) {
                                if (element.options.synLinkFormFieldId) {
                                    if (element.options.synLinkFormFieldId === fieldObj.id) {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData, index);
                                    }
                                } else {
                                    if (sourceFieldLabel === element.name && element.type === 'text') {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData, index);
                                    }
                                }
                            }
                        });
                    });
                    selectTableColumns.forEach(fieldObj => {
                        if (fieldObj.type === 'subform') {
                            // console.log(fieldObj);
                            // console.log(currentlinkFieldId);// 当前表单的关联字段id
                            targetFormFieldlist.forEach(element => {
                                // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                                if (element.options.dataSourceFieldId && element.options.dataSourceFieldId === currentlinkFieldId) {
                                    if (element.options.dataSourceSubFieldId) {
                                        if (element.options.dataSourceSubFieldId === fieldObj.id) {
                                            if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                                                for (let i = 0; i < this.forms[index].fieldsList.length; i++) {
                                                    let tempField = this.forms[index].fieldsList[i];
                                                    if (element.id === tempField.id) {
                                                        this.$refs['fieldItemChild' + i][0].reSetSelectOptions(element, fieldObj, sourceData);
                                                    }
                                                }
                                            }
                                            // this.reSetSelectOptions(element, fieldObj, sourceData, index);
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
                for (let i = 0; i < this.forms.length; i++) {
                    let form = this.forms[i];
                    let field = form.fieldsList.find(element => element.id === currentlinkFieldId);
                    if (field.options.ext2) {
                        let ext2 = field.options.ext2;
                        let ext2Obj = JSON.parse(ext2);
                        if (ext2Obj.automaticRecodeRefField) { // 配置了自动带出
                            let automaticRecodeFields = ext2Obj.automaticRecodeFields;
                            let automaticRecodeFieldsArray = automaticRecodeFields.split(',');
                            for (let i = 0; i < automaticRecodeFieldsArray.length; i++) {
                                let automaticRecodeFieldsItem = automaticRecodeFieldsArray[i];
                                let fieldObj = form.fieldsList.find(element => element.id === automaticRecodeFieldsItem);
                                if (fieldObj) {
                                    await this.getTableFirstRefData(fieldObj, form.fieldsList, index);
                                }
                            }
                        }
                    }
                }
            },
            async getTableFirstRefData (fieldObj, fieldsList, index) {
                let refTableData = [];
                let refTableColumn = [];
                this.searchParamsField.searchCondition = [];// 初始化搜索条件
                if (fieldObj.ext1 && this.searchParamsField.searchCondition.length === 0) { // 默认筛选值
                    let obj = JSON.parse(fieldObj.ext1);
                    this.defaultConditonsMap = new Map();
                    for (let key in obj) {
                        obj[key]['modelId'] = fieldObj.options.config.form.modelId;
                        this.searchParamsField.searchCondition.push(obj[key]);
                        this.defaultConditonsMap.set(obj[key].id, obj[key]);
                    }
                    this.searchCondition = this.searchParamsField.searchCondition;
                }
                // 任务表单内选择关联数据，默认从前3000条数据中进行筛选。
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await this.setDefaultConditionRef(fieldObj);
                for (let i = 0; i < this.searchParamsField.searchCondition.length; i++) {
                    let defaultCondition = this.searchParamsField.searchCondition[i];
                    if (defaultCondition.operateType === 7) { // 从表单字段值取值搜索
                        let searchvalue = this.formData[defaultCondition.valueFieldId];
                        let cur = fieldsList.find(element => element.id === defaultCondition.valueFieldId);
                        let searchvalueView = '';
                        if (cur.type === 'category' || cur.type === 'select') {
                            searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-view'];
                            let options = defaultCondition.options.config.options;
                            for (let i = 0; i < options.length; i++) {
                                let item = options[i];
                                if (item.title === searchvalueView) {
                                    searchvalue = item.value;
                                }
                            }
                        } else if (cur.type === 'department') {
                            searchvalue = this.formData[index].values[defaultCondition.valueFieldId + '-tree'];
                            searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-tree'];
                        }
                        if (searchvalue) {
                            defaultCondition.conditionValue = searchvalue;
                            defaultCondition.conditionValueView = searchvalueView;
                            defaultCondition.operateType = 1;
                        }
                    }
                }
                // 处理关联字段值的搜索
                let formData = await getModelFormReportList({
                    currentPage: 1,
                    pageSize: 1,
                    modelId: fieldObj.options.config.form.modelId,
                    formId: fieldObj.options.config.form.formId,
                    isRelationSearch: true,
                    isFromFieldItemLink: true, // 是否进行关联字段的表单数据查询
                    processInstanceId: this.processInstanceId,
                    searchCondition: this.searchParamsField.searchCondition
                });
                if (formData.data) {
                    let tableDatas = [];
                    formData.data.forEach(item => {
                        let jsonObj = JSON.parse(item);
                        tableDatas.push(jsonObj);
                    });
                    refTableData = tableDatas;
                    loading.close();
                }
                if (formData.otherData) {
                    refTableColumn = formData.otherData.tableColumns;
                }
                //   this.loadTimer = new Date().getTime();
                if (fieldObj.options.config.form.selectTableHeaderFields) { // 配置了关联列表模型显示表头
                    let cacheTableColumns = [];
                    for (let i = 0; i < refTableColumn.length; i++) {
                        let cur = refTableColumn[i];
                        if (fieldObj.options.config.form.selectTableHeaderFields.indexOf(cur.id) !== -1) {
                            cacheTableColumns.push(cur);
                        }
                    }
                    refTableColumn = cacheTableColumns;
                }
                if (refTableData.length > 0) {
                    let param = {row: refTableData[0]};
                    this.handelSelectRefRow(param, fieldObj, refTableColumn, index);
                }
            },
            handelSelectRefRow (params, fieldObj, refTableColumn, index) { // TODO
                let selData = cloneDeep(params.row);
                let selectTableData = [selData];// 复制当前选中数据
                let linkData = this.setLinkTableData(refTableColumn, selectTableData[0]);
                let curFieldData = {
                    modelId: fieldObj.options.config.form.modelId,
                    tableColumns: refTableColumn,
                    tableData: [linkData]
                };
                this.formData[index].values[fieldObj.id] = curFieldData;
                this.formData[index].values[fieldObj.id + '-link'] = linkData.id;
                // this.formData[index].values[fieldObj.id + '-view'] = linkData[refTableColumn[1].id];
                this.formData[index].values[fieldObj.id + '-view'] = linkData[refTableColumn[0].id];
            },
            setLinkTableData (selectTableColumns, sourceFormObj) { // 增加关联字段显示字段的冗余字段数据
                let linkData = {};
                if (sourceFormObj) {
                    linkData['id'] = sourceFormObj.id;
                    if (selectTableColumns && selectTableColumns.length > 0) {
                        let selectcolumns = cloneDeep(selectTableColumns);
                        // console.log(selectcolumns);
                        selectcolumns.forEach(item => {
                            if (item.type === 'dictionary' || item.type === 'businessTree' || item.type === 'department') {
                                // -tree
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-tree'] = sourceFormObj[item.id + '-tree'];
                            } else if (item.type === 'user') {
                                // -user
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-user'] = sourceFormObj[item.id + '-user'];
                            } else if (item.type === 'category' || item.type === 'select' || item.type === 'file' || item.type === 'process' || item.type === 'address' || item.type === 'cascader' || item.type === 'role') {
                                // -view
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                            } else if (item.type === 'calculation' || item.type === 'number' || item.type === 'text' || item.type === 'serialNumber' || item.type === 'date') {
                                linkData[item.id] = sourceFormObj[item.id];
                            } else if (item.type === 'link') {
                                linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                            } else if (item.type === 'subform') {
                                linkData[item.id] = sourceFormObj[item.id];
                            }
                        });
                    }
                }
                return linkData;
            },
            async setDefaultConditionRef (fieldObj) {
                if (fieldObj.options.ext3 && fieldObj.options.ext3 === '1' && !isEmpty(this.defaultConditonsMap)) { // 设置过滤条件为固定模式
                    if (this.searchParamsField.searchCondition && Array.isArray(this.searchParamsField.searchCondition)) {
                        let defaultConditons = [];
                        this.searchParamsField.searchCondition.forEach(conditiontObj => {
                            if (this.defaultConditonsMap.has(conditiontObj.id)) {
                                let defaultCondition = this.defaultConditonsMap.get(conditiontObj.id);
                                if (defaultCondition && defaultCondition.conditionValue) {
                                    defaultConditons.push(defaultCondition);
                                } else {
                                    defaultConditons.push(conditiontObj);
                                }
                            } else {
                                defaultConditons.push(conditiontObj);
                            }
                        });
                        if (!isEmpty(defaultConditons)) {
                            this.searchParamsField.searchCondition = defaultConditons;
                        }
                    }
                }
                if (fieldObj.options.ext2) {
                    let def = JSON.parse(fieldObj.options.ext2);
                    if (def.linkConfig) {
                        let linkConfig = JSON.parse(def.linkConfig);
                        if (linkConfig.linkConfigState) { // 需要过滤数据
                            this.searchParamsField.searchCondition = [];
                            let key = linkConfig.id + '-link';
                            let value = this.formData[key];
                            let curObj = JSON.parse(linkConfig.linkFieldObj);
                            curObj.conditionValue = value;
                            curObj.operateType = 2;
                            this.searchParams.searchCondition.push(curObj);
                        }
                    }
                }
                await this.setLinkLimitDataRef(fieldObj);
            },
            async setLinkLimitDataRef (fieldObj) {
                if (fieldObj.options.ext2) { // 子表单的值进行约束，例如只能查看自己作为项目成员参与的项目列表
                    let json = JSON.parse(fieldObj.options.ext2);
                    if (json.limitData === true && json.limitFieldDataArray && json.limitFieldDataArray.length > 0) {
                        let relateFormId = fieldObj.options.config.form.formId; // 关联字段的关联表单id
                        let formData = await getFormConfig(relateFormId);
                        if (formData) {
                            let fieldsList = formData.fieldsList;
                            if (fieldsList && fieldsList.length > 0) {
                                let conditonsMap = new Map();
                                for (let i = 0; i < json.limitFieldDataArray.length; i++) {
                                    let limitField = json.limitFieldDataArray[i];
                                    if (limitField.subFormFieldId) {
                                        let linkPropFieldId = limitField.linkPropFieldId;// 子表单字段
                                        let subFormFieldId = limitField.subFormFieldId;
                                        conditonsMap.set(linkPropFieldId, linkPropFieldId + ',' + subFormFieldId);
                                    }
                                }
                                for (let k = 0; k < fieldsList.length; k++) {
                                    let curfield = fieldsList[k];
                                    if (curfield.type === 'subform' && conditonsMap.has(curfield.id)) {
                                        let targetStr = conditonsMap.get(curfield.id);
                                        curfield.filterMainFieldId = targetStr.split(',')[0];
                                        curfield.filterSubField = targetStr.split(',')[1];
                                        this.searchParamsField.searchCondition.push(curfield);
                                    }
                                }
                            }
                        }
                    }
                }
            },
            // 修改配置了关联映射的字段值
            updSynLinkFieldData (element, fieldObj, sourceData, index) {
                // console.log(element);
                let type = fieldObj.type;
                let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
                let can = false; // 是否支持级联显示
                if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                    // -tree
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-tree'];
                } else if (type === 'user') {
                    // -user
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-user'];
                } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                    // -view
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                    if (element.options.synLinkFormField && element.options.synLinkFormField.type && element.options.synLinkFormField.type === 'category' && element.options.synLinkFormField.options.config.type === 'multi') {
                        let cacheValue = sourceData[fieldObj.id];
                        let cacheValueArray = [];
                        for (let i = 0; i < fieldObj.otherSetting.colorOne.length; i++) {
                            let cur = fieldObj.otherSetting.colorOne[i];
                            if (cacheValue.indexOf(cur.value) !== -1) {
                                cacheValueArray.push(cur.title);
                            }
                        }
                        sourceValue = cacheValueArray.join(',');
                    }
                } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                } else if (type === 'link') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                } else if (type === 'subform') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                }
                if (can) {
                    if (element.type === 'text') {
                        this.formData[index].values[element.id] = sourceValue;
                        this.formData[index].values[element.id + '-view'] = '';
                    } else if (element.type === 'select') {
                        // console.log(element);
                        if (!isEmpty(sourceValue)) {
                            // 下拉选项值
                            let targetFieldValue = {};
                            let targetFieldOptions = element.options.config.options;
                            for (let i = 0; i < targetFieldOptions.length; i++) {
                                let optionItem = targetFieldOptions[i];
                                if (optionItem.title === sourceValue) {
                                    targetFieldValue = optionItem;
                                    break;
                                }
                            }
                            if (targetFieldValue) {
                                this.formData[index].values[element.id] = targetFieldValue.value;
                                this.formData[index].values[element.id + '-view'] = targetFieldValue.title;
                            }
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-view'] = '';
                        }
                    } else if (element.type === 'subform') {
                        let sourceSubColumns = fieldObj.subColumns;
                        if (isEmpty(sourceSubColumns)) { // 智能关联，需要这样取值
                            sourceSubColumns = fieldObj.options.fieldList;
                            for (let k = 0; k < sourceSubColumns.length; k++) {
                                sourceSubColumns[k].label = sourceSubColumns[k].name;
                            }
                        }
                        let taragetSubColumns = element.options.fieldList;
                        let newValue = [];
                        // console.log(sourceSubColumns);
                        // console.log(taragetSubColumns);
                        // console.log(element);
                        // console.log(sourceValue);
                        if (!isEmpty(sourceValue)) {
                            for (let i = 0; i < sourceValue.length; i++) {
                                let sourceItemValue = sourceValue[i];
                                let targetItemValue = {};
                                // console.log(sourceItemValue);
                                for (let j = 0; j < taragetSubColumns.length; j++) { // 寻找同名的字段，然后获取其值付给目标字段
                                    let targetColumn = taragetSubColumns[j];
                                    for (let k = 0; k < sourceSubColumns.length; k++) {
                                        let sourceColumn = sourceSubColumns[k];
                                        if (targetColumn.label === sourceColumn.label) {
                                            if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
                                                // -tree
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-tree'];
                                            } else if (sourceColumn.type === 'user') {
                                                // -user
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-user'];
                                            } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
                                                // -view
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-view'];
                                            } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id];
                                            }
                                            break;
                                        }
                                    }
                                }
                                if (!isEmpty(targetItemValue)) {
                                    newValue.push(targetItemValue);
                                }
                            }
                            // console.log(newValue);
                            this.formData[index].values[element.id] = newValue;
                        } else {
                            this.formData[index].values[element.id] = '';
                        }
                    }
                }
            },
            // reSetSelectOptions (element, fieldObj, sourceData, index) {
            //     let type = fieldObj.type;
            //     let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
            //     if (type === 'subform') {
            //         sourceValue = sourceData[fieldObj.id];
            //         if (element.type === 'select') {
            //             let sourceSubColumns = fieldObj.subColumns;
            //             if (isEmpty(sourceSubColumns)) { // 智能关联，需要这样取值
            //                 sourceSubColumns = fieldObj.options.fieldList;
            //                 for (let k = 0; k < sourceSubColumns.length; k++) {
            //                     sourceSubColumns[k].label = sourceSubColumns[k].name;
            //                 }
            //             }
            //             let newOptions = [];
            //             // console.log(sourceSubColumns);
            //             // console.log(taragetSubColumns);
            //             // console.log(element);
            //             // console.log(sourceValue);
            //             if (!isEmpty(sourceValue)) {
            //                 for (let i = 0; i < sourceValue.length; i++) {
            //                     let sourceItemValue = sourceValue[i];
            //                     let targetItemValue = {
            //                         id: '',
            //                         title: '',
            //                         value: '',
            //                         def: false,
            //                         optionConfigId: element.options.config.id,
            //                         formId: element.formId
            //                     };
            //                     // console.log(sourceItemValue);
            //                     for (let k = 0; k < sourceSubColumns.length; k++) {
            //                         let sourceColumn = sourceSubColumns[k];
            //                         if (element.name === sourceColumn.label) {
            //                             if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
            //                                 // -tree
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id + '-tree'];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id + '-tree'];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id + '-tree'];
            //                             } else if (sourceColumn.type === 'user') {
            //                                 // -user
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id + '-user'];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id + '-user'];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id + '-user'];
            //                             } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
            //                                 // -view
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id + '-view'];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id + '-view'];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id + '-view'];
            //                             } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id];
            //                             }
            //                             break;
            //                         }
            //                     }
            //                     if (!isEmpty(targetItemValue)) {
            //                         newOptions.push(targetItemValue);
            //                     }
            //                 }
            //             }
            //             // console.log(newOptions);
            //             // 重置选项list
            //             // let formInfo = this.formInfo.formObj.structure[0];
            //             // if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
            //             //     for (var i = 0; i < formInfo.fieldsList.length; i++) {
            //             //         let tempField = formInfo.fieldsList[i];
            //             //         if (element.id === tempField.id) {
            //             //             this.$refs['fieldItemChild' + i][0].resetSelectFieldOptions(newOptions);
            //             //         }
            //             //     }
            //             // }
            //             if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
            //                 for (var i = 0; i < this.forms[index].fieldsList.length; i++) {
            //                     let tempField = this.forms[index].fieldsList[i];
            //                     if (element.id === tempField.id) {
            //                         this.$refs['fieldItemChild' + i][0].resetSelectFieldOptions(newOptions);
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // },
            isShowCascadeField (field, values) {
                return isFormFieldVisible(field, values);
            },
            isShowNormalField (field, index, formData) {
                if (!field || !formData || !formData.values || !isFormFieldVisible(field, formData.values)) {
                    return false;
                }
                let subFormViewMode = formData.values['subFormViewMode'];
                if (subFormViewMode !== 0 && (formData.ext1 === 1 || subFormViewMode === 1)) { // 子表单页签模式
                    if (field.type === 'subform') {
                        return false;
                    } else {
                        return true;
                    }
                } else if (formData.ext1 === 0 || !subFormViewMode || subFormViewMode === 0) { // 子表单正常模式
                    return true;
                }
            },
            changeProportionVal (obj) {
                this.renderTimer = new Date().getTime();
            },
            initApprovePeople () {
                let depUserLinkUserArr = [];
                if (this.approvalInfo.approvalMethod == 3) { // 表单字段动态审批人，带出表单人员赋值到审批流上
                    // 根据部门指定的审批人，重置当前审批流的审批人begin
                    // 是配置了按部门选人模式的话，根据填写的部门信息获取配置的审批人
                    let deptUserlinkData = this.approvalTemplateObj.deptUserlinkData;
                    let onlyUserNode = false;
                    if (deptUserlinkData && deptUserlinkData.length > 0) {
                        for (let i = 0; i < deptUserlinkData.length; i++) {
                            let deptUserlinkDataItem = deptUserlinkData[i];
                            for (let k = 0; k < this.formData.length; k++) {
                                let form = this.formData[k];
                                if (deptUserlinkDataItem.formId === form.formId) {
                                    let values = form.values;
                                    let deptId = values[deptUserlinkDataItem.formFieldId];
                                    // console.log(deptId);
                                    // if (deptId && deptId == deptUserlinkDataItem.formFieldValue) {
                                    let matchFlg = false;
                                    // edit by hezhen 进行部门多选时的逻辑重构
                                    if (deptUserlinkDataItem.formFieldValue && deptUserlinkDataItem.formFieldValue.indexOf(',') !== -1) {
                                        matchFlg = deptId && deptUserlinkDataItem.formFieldValue.indexOf(deptId) !== -1;
                                    } else {
                                        matchFlg = deptId && deptId == deptUserlinkDataItem.formFieldValue;
                                    }
                                    // if (deptId && deptId == deptUserlinkDataItem.formFieldValue) {
                                    if (matchFlg) {
                                        if (deptUserlinkDataItem.selectedUserIds) {
                                            let userIdArr = deptUserlinkDataItem.selectedUserIds.split(',');
                                            let trueNameArr = deptUserlinkDataItem.selectedUserNames.split(',');
                                            onlyUserNode = deptUserlinkDataItem.onlyUserNode;
                                            for (let j = 0; j < userIdArr.length; j++) {
                                                let userBo = {userId: '', trueName: ''};
                                                userBo.userId = userIdArr[j];
                                                userBo.trueName = trueNameArr[j];
                                                depUserLinkUserArr.push(userBo);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // console.log(depUserLinkUserArr);
                    // 根据部门指定的审批人，重置当前审批流的审批人end

                    if (depUserLinkUserArr.length > 0 && !onlyUserNode) {
                        // 部门指定负责人，覆盖默认的负责人信息begin
                        this.approvalInfo.approvePeopleList = [];
                        for (let k = 0; k < depUserLinkUserArr.length; k++) {
                            let curUserBo = depUserLinkUserArr[k];
                            let approvalNode = {
                                id: '',
                                approveOrder: k,
                                approveWay: 1,
                                approvePeoples: []
                            };
                            let approvalUser = {};
                            approvalUser.selectedUserId = curUserBo.userId;
                            approvalUser.selectedUserName = curUserBo.trueName;
                            approvalUser.approvePeopleType = 'user';
                            approvalNode.approvePeoples.push(approvalUser);
                            this.approvalInfo.approvePeopleList.push(approvalNode);
                        }
                        // 部门指定负责人，覆盖默认的负责人信息end
                    } else {
                        // this.approvalInfo.approvePeopleList = clone(this.defaultApprovePeopleList);
                        this.approvalInfo.approvePeopleList = JSON.parse(JSON.stringify(this.defaultApprovePeopleList));
                        let approvePeopleList = this.approvalInfo.approvePeopleList;
                        if (approvePeopleList && approvePeopleList.length > 0) {
                            for (let i = 0; i < approvePeopleList.length; i++) {
                                let approvePeoples = approvePeopleList[i].approvePeoples;
                                // 根据部门指定的审批人，只重置类型未user的节点的审批人begin
                                if (depUserLinkUserArr.length > 0 && onlyUserNode) {
                                    let isUsed = false;
                                    let curUserBo = depUserLinkUserArr[0]; // 获取部门人员配置的人员信息.每次从第一条获取，用完后移除
                                    if (approvePeoples[0].approvePeopleType === 'user') {
                                        approvePeoples[0].selectedUserId = curUserBo.userId;
                                        approvePeoples[0].selectedUserName = curUserBo.trueName;
                                        isUsed = true;
                                    }
                                    if (isUsed) {
                                        depUserLinkUserArr.shift();
                                    }
                                }
                                // 根据部门指定的审批人，只重置类型未user的节点的审批人end
    
                                for (let j = 0; j < approvePeoples.length; j++) {
                                    let cur = approvePeoples[j];
                                    if (cur.approvePeopleType == 'formField') {
                                        let formId = cur.formId;
                                        let fieldId = cur.id;
                                        for (let k = 0; k < this.formData.length; k++) {
                                            let form = this.formData[k];
                                            if (formId == form.formId) {
                                                let values = form.values;
                                                let userid = values[fieldId];
                                                let trueName = values[fieldId + '-user'];
                                                if (trueName != '' && userid != '') {
                                                    approvePeoples[j].trueName = trueName;
                                                    approvePeoples[j].userid = userid;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            // console.log(approvePeopleList);
                        }
                    }
                }
            },
            // 根据选择的部门，来确定审批人
            initDeptApprovePeople () {
                // console.log(this.approvalInfo);
                // console.log(this.approvalTemplateObj);
                if (this.approvalInfo.approvalMethod === 1) { // 部门表单字段动态审批人，带出审批人员赋值到审批流上
                    let deptUserlinkData = this.approvalTemplateObj.deptUserlinkData;
                    if (deptUserlinkData && deptUserlinkData.length > 0) {
                        for (let i = 0; i < deptUserlinkData.length; i++) {
                            let deptUserlinkDataItem = deptUserlinkData[i];
                            for (let k = 0; k < this.formData.length; k++) {
                                let form = this.formData[k];
                                if (deptUserlinkDataItem.formId === form.formId) {
                                    let values = form.values;
                                    // console.log(values);
                                    let deptId = values[deptUserlinkDataItem.formFieldId];
                                    // console.log(deptId);
                                    // if (deptId && deptId === deptUserlinkDataItem.formFieldValue * 1) {
                                    // if (deptId && deptId == deptUserlinkDataItem.formFieldValue) {
                                    let matchFlg = false;
                                    // edit by hezhen 进行部门多选时的逻辑重构
                                    if (deptUserlinkDataItem.formFieldValue && deptUserlinkDataItem.formFieldValue.indexOf(',') !== -1) {
                                        matchFlg = deptId && deptUserlinkDataItem.formFieldValue.indexOf(deptId) !== -1;
                                    } else {
                                        matchFlg = deptId && deptId == deptUserlinkDataItem.formFieldValue;
                                    }
                                    // if (deptId && deptId == deptUserlinkDataItem.formFieldValue) {
                                    if (matchFlg) {
                                        this.approvalInfo.selectedUserIds = deptUserlinkDataItem.selectedUserIds;
                                        this.approvalInfo.selectedUserNames = deptUserlinkDataItem.selectedUserNames;
                                        this.approvalForm.selectedUser.selectedUserIds = this.approvalInfo.selectedUserIds;
                                        this.approvalForm.selectedUser.selectedUserNames = this.approvalInfo.selectedUserNames;
                                        this.selectUsers = [];
                                        this.selectUsers = this.approvalInfo.selectedUserNames.split(',');
                                    }
                                }
                            }
                        }
                    }
                }
            },
            // 根据命名规则组合审批名称
            getDefaultApproveName () {
                let nameArray = [];
                let titleRuleBOs = this.approvalTemplateObj.titleRuleBOs;
                if (titleRuleBOs && titleRuleBOs.length > 0) {
                    for (let i = 0; i < titleRuleBOs.length; i++) {
                        let titleRuleBO = titleRuleBOs[i];
                        if (titleRuleBO.titleType === 0) {
                            nameArray.push('【' + titleRuleBO.titleValue + '】');
                        } else if (titleRuleBO.titleType === 1) {
                            let yy = new Date().getFullYear();
                            let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
                            let dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
                            let hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
                            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
                            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
                            let currentTime = yy + '' + mm + '' + dd;
                            if (titleRuleBO.titleValue === 'yyyyMMdd') {
                                currentTime = yy + '' + mm + '' + dd;
                            } else if (titleRuleBO.titleValue === 'yyyyMMddHHmmss') {
                                currentTime = yy + '' + mm + '' + dd + '' + hh + '' + mf + '' + ss;
                            }
                            nameArray.push(currentTime);
                        } else if (titleRuleBO.titleType === 2) {
                            let sourceValue = '';
                            for (let k = 0; k < this.formData.length; k++) {
                                let form = this.formData[k];
                                if (titleRuleBO.formId === form.formId) {
                                    let sourceData = form.values;
                                    if (titleRuleBO.fieldType === 'dictionary' || titleRuleBO.fieldType === 'businessTree' || titleRuleBO.fieldType === 'department') {
                                        // -tree
                                        sourceValue = sourceData[titleRuleBO.titleValue + '-tree'];
                                    } else if (titleRuleBO.fieldType === 'user') {
                                        // -user
                                        sourceValue = sourceData[titleRuleBO.titleValue + '-user'];
                                    } else if (titleRuleBO.fieldType === 'category' || titleRuleBO.fieldType === 'select' || titleRuleBO.fieldType === 'file' || titleRuleBO.fieldType === 'process' || titleRuleBO.fieldType === 'address' || titleRuleBO.fieldType === 'cascader' || titleRuleBO.fieldType === 'role') {
                                        // -view
                                        if (titleRuleBO.fieldType === 'select') {
                                            if (!isEmpty(sourceData[titleRuleBO.titleValue + '-view'])) {
                                                sourceValue = '【' + sourceData[titleRuleBO.titleValue + '-view'] + '】';
                                            }
                                        } else {
                                            sourceValue = sourceData[titleRuleBO.titleValue + '-view'];
                                        }
                                    } else if (titleRuleBO.fieldType === 'calculation' || titleRuleBO.fieldType === 'number' || titleRuleBO.fieldType === 'text' || titleRuleBO.fieldType === 'serialNumber' || titleRuleBO.fieldType === 'date') {
                                        sourceValue = sourceData[titleRuleBO.titleValue];
                                    } else if (titleRuleBO.fieldType === 'link') {
                                        sourceValue = sourceData[titleRuleBO.titleValue + '-view'];
                                    }
                                    break;
                                }
                            }
                            nameArray.push(sourceValue);
                        }
                    }
                }
                if (nameArray && nameArray.length > 0) {
                    let name = '';
                    // for (let i = 0; i < nameArray.length; i++) {
                    //     if (!isEmpty(nameArray[i])) {
                    //         name = name + nameArray[i] + '-';
                    //     }
                    // }
                    name = nameArray.join('—');
                    if (!isEmpty(name)) {
                        this.approvalForm.approvalName = name;
                    }
                }
            },
            handleClose (obj) {
                for (let i = 0; i < this.copyUserObj.length; i++) {
                    if (this.copyUserObj[i].id === obj.id) {
                        this.copyUserObj.splice(i, 1);
                    }
                }
            },
            confirmCopyFieldUserOrg () {
                if (this.$refs.copyFieldUserOrg) {
                    this.$refs.copyFieldUserOrg.setChoosedUser();
                    let selectedUserIds = this.selectedCopyFieldUser.selectedUserIds;
                    let selectedUserNames = this.selectedCopyFieldUser.selectedUserNames;
                    let selectedUserIdsArray = selectedUserIds.split(',');
                    let selectedUserNamesArray = selectedUserNames.split(',');
                    if (this.approvalTemplateObj.approvalStatus === 1) {
                        this.copyUserObjTwo = [];
                        for (let j = 0; j < this.copyUserObjTwo.length; j++) {
                            if (this.copyUserObjTwo[j].approvePeopleType === 'user') {
                                this.copyUserObjTwo.splice(j, 1);
                            }
                        }
                        for (let i = 0; i < selectedUserIdsArray.length; i++) {
                            let userId = selectedUserIdsArray[i];
                            let trueName = selectedUserNamesArray[i];
                            let item = {userId: userId, trueName: trueName};
                            item.id = this.generateUUID();
                            item.approvePeopleType = 'user';
                            this.copyUserObjTwo.push(item);
                        }
                        let copyUserIdsArray = [];
                        let copyUserNamesArray = [];
                        this.copyUserObj.forEach(item => {
                            copyUserIdsArray.push(item.userId);
                            copyUserNamesArray.push(item.trueName);
                        });
                        this.copyUserObjTwo.forEach(item => {
                            copyUserIdsArray.push(item.userId);
                            copyUserNamesArray.push(item.trueName);
                        });
                        this.approvalInfo.selectedCopyUserIds = copyUserIdsArray.join(',');
                        this.approvalInfo.selectedCopyUserNames = copyUserNamesArray.join(',');
                    } else {
                        for (let j = 0; j < this.copyUserObj.length; j++) {
                            if (this.copyUserObj[j].approvePeopleType === 'user') {
                                this.copyUserObj.splice(j, 1);
                            }
                        }
                        for (let i = 0; i < selectedUserIdsArray.length; i++) {
                            let userId = selectedUserIdsArray[i];
                            let trueName = selectedUserNamesArray[i];
                            let item = {userId: userId, trueName: trueName};
                            item.id = this.generateUUID();
                            item.approvePeopleType = 'user';
                            this.copyUserObj.push(item);
                        }
                    }
                    this.isShowCopyFieldUserOrg = false;
                }
            },
            addCopyFieldUser () {
                this.isShowCopyFieldUserOrg = true;
                setTimeout(() => { // 初始化
                    if (this.$refs.copyFieldUserOrg) {
                        this.$refs.copyFieldUserOrg._initPage();
                    }
                }, 0);
                let selectedUserIds = [];
                let selectedUserNames = [];
                this.copyUserObj.forEach(item => {
                    if (item.approvePeopleType === 'user') {
                        selectedUserIds.push(item.userId);
                        selectedUserNames.push(item.trueName);
                    }
                });
                this.selectedCopyFieldUser = {selectedUserIds: selectedUserIds.join(','), selectedUserNames: selectedUserNames.join(',')};
            },
            addNewCopyFieldUser () {
                setTimeout(() => { // 初始化
                    this.$refs.copyFieldUserOrg._initPage();
                }, 0);
                let selectedUserIds = [];
                let selectedUserNames = [];
                this.copyUserObjTwo.forEach(item => {
                    if (item.approvePeopleType === 'user') {
                        selectedUserIds.push(item.userId);
                        selectedUserNames.push(item.trueName);
                    }
                });
                this.selectedCopyFieldUser = {selectedUserIds: selectedUserIds.join(','), selectedUserNames: selectedUserNames.join(',')};
                this.isShowCopyFieldUserOrg = true;
            }
        }
    };
</script>

<style lang="less">
    .approval-pop {
        margin-top:-2px;
        width: 100%;
        height: 100%;
        // height: ~"calc(100% - 120px)";
        overflow-y: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
        .is-disabled{
            .el-input__inner{
                color: #524747!important;
            }
        }
        .is-disabled+span{
            .el-radio__label{
                color: #524747!important;
            }
        }
        .el-radio-button__orig-radio:disabled+.el-radio-button__inner{
            color: #524747!important;
        }
        .el-step__main .el-breadcrumb{
            display: inline-block;
            .el-breadcrumb__item{
                float: none;
                .el-breadcrumb__inner{
                    color:#409eff;
                    a:hover{
                        color:#409eff;
                    }
                }
                .el-breadcrumb__separator{
                    color:#409eff;
                }
            }
        }
        .instances-head{
          width: 55%;
        }
        .instances-desc {
            // margin: 15px 15px;
            margin: 15px 6px 15px 0px;
            .el-card__body {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }

        .desc-content2 {
            margin: 5px 0 0 0;
            & > span {
                margin: 0 10px 0 0;
            }
        }

        .instances-content {
            flex: 1;
            // padding: 0 15px;
            // margin-top: -10px;
            display: flex;
            flex-direction: row;
            padding: 10px;
            // .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
            //   margin-bottom:2px
            // }

            .content-instanceRecord{
              margin-top: -12px;
              .el-card__header{
                padding: 8px 20px;
              }
            }
        }

       .content-left {
            width: 90%;
            margin: 0 5px;
            overflow-y: auto;
        }
       .content-form-left {
            width: 100%;
            margin: 0 5px;
            overflow-y: auto;
        }
        // .content-center {
        //      width: 35%;
        //      margin: 0 5px;
        //      overflow-y: auto;
        // }
        .content-right {
             width: 65%;
             margin: 0 5px;
             overflow-y: auto;
        }
        .sideboxcls {
            width: 30%;
            // height: 30%;
            overflow-y: auto;
        }
        .comments {
            width: 100%;
            height: 350px;
            overflow-y: auto;
        }
        .record-list {
            margin-top: -12px;
            width: 100%;
            height: 350px;
            overflow-y: auto;
            // width: 350px;
        }
        .record-item {
            font-size: 12px;
            height: 70px;

            display: flex;
            flex-direction: column;
        }
        .record-content1 {
            font-weight: 700;
            font-size: 14px;
            display: flex;
            flex-direction: row;
        }
        .record-content2 {
            color: #67c23a;
        }
        .record-content3 {
            color: #adadad;
        }
        .record-content4 {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-items: center;
        }
        .record-icon {
            font-size: 14px;
            width: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .record-line {
            & > span {
                background: #ebeef5;
                width: 2px;
                height: 100%;
            }
        }
        .record-opinion{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;// 限制快级元素的文本行数
          overflow: hidden;
          font-size:12px;
          font-weight:500;
        }

        .diagram-dialog {
            // height: 650px;
            // height: 80%;
        }

        .el-collapse-title {
          // color: #409eff;
          color: #4ebe17;
          // font-size: 18px;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          & > .el-button {
              margin-right: 10px;
          }
        }
        .process-detail-Forms{
          .el-form-item__label{
            color: #333;
            font-weight: 700;
          }
        }
        .el-tabs__content{
          margin-top: 3px;
          padding: 0px 1px 0px 20px;
          height: ~"calc(100% - 50px)";
          .el-tab-pane{
             height: 100%;
             .el-collapse{
                //  height: ~"calc(100% - 10px)";
                 .el-collapse-item{
                    //  height: 100%;
                     .el-collapse-item__wrap{
                        // height: 100%;
                        overflow: hidden;
                     }
                 }
             }
          }
        }
        .approvalRemarksStyle{
          .el-textarea__inner{
            // background-color: #ecf5ff;
            // border-color: #b3d8ff;
              background-color: #f0f9eb;
              border-color: #c2e7b0;
          }
        }
        .el-form {
            width: 100%;
            .el-cascader--small,.el-select--small{
                width: 100%;
            }
            .render-form-item{
                .el-row{
                    display: flex;
                    .subform-field-item{
                        width:~"calc(100% - 10px)";
                    }
                }
                .relateFormTab {
                    .el-tabs__header {
                        margin: 0 0 2px;
                    }
                }
            }
        }
        .executors-proportion{
            display: flex;
            flex-direction: row;
            .el-step{
               .el-step__head{
                   display: none;
               }
            }
            .opera-btn{
                display: none;
            }
            .el-icon-question{
                cursor: pointer;
                font-size: 20px;
            }
        }
    }
    .approval-pop-dialog{
      .el-dialog__header{
        padding: 5px 20px 10px;
      }
      .el-dialog__footer{
        // padding: 10px 20px 5px 5px;
      }
      .el-dialog__body{
        height: 540px;
        padding: 5px 5px;
      }
      .el-dialog{
          .el-dialog__body{
            height: ~"calc(100% - 120px)";
            overflow: auto;
            .approval-pop{
               .instances-content{
                   position: relative;
                   height: ~"calc(100% - 50px)";
                   .form-card{
                       height: 100%;
                       position: relative;
                       .el-tabs__content{
                          height: ~"calc(100% - 50px)";
                          position: relative;
                          .el-tab-pane{
                              height: 100%;
                              position: relative;
                              overflow: auto;
                              .el-form{
                               height: 100%;
                               position: relative;
                               .el-form-item{
                                  height: 100%;
                                  position: relative;
                               }
                             }
                          }
                       }
                   }
               }
            }
          }
      }
    }
    .show-all-approval-pop-dialog{
        .el-dialog{
            .el-dialog__body{
              height: ~"calc(100% - 120px)";
              overflow: auto;
              .approval-pop{
                  height: 100%;
              }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ApprovalPop/ApprovalPop.vue